import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { getTranslate } from "react-localize-redux";
import moment from "moment";
import AnimateHeight from "react-animate-height";
import {
  ButtonGroup,
  Button,
  Label,
  Input,
  TabContent,
  TabPane,
  Nav,
  NavItem,
  NavLink,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  FormGroup,
  Row,
  Col,
} from "reactstrap";
import classnames from "classnames";
import Select from "react-select";
import Datetime from "react-datetime";
import { actions } from "react-redux-form";
import axios from "axios";
import { FixedSizeList as List } from "react-window";
import ReactTooltip from "react-tooltip";
import { isMobile } from "react-device-detect";
import {
  configActions,
  fileActions,
  loaderMaskActions,
  msgActions,
  reportActions,
} from "../../../../redux/actions";
import { QuickDownloadButton } from "../../../../components/QuickDownloadButton";
import { getFilesParams, getMomentLocaleByLang } from "../../../../utils/utils";

import "./SearchPanel.css";

var cur_date = new Date(),
  min_date;

min_date = new Date(
  cur_date.getFullYear(),
  cur_date.getMonth(),
  cur_date.getDate(),
  "00",
  "00",
  "00",
  "000"
);
min_date = moment(min_date);
min_date.subtract(13, "month").subtract(1, "day");

const height = 10;

class MenuList extends Component {
  render() {
    const { options, children, maxHeight, getValue } = this.props;
    const [value] = getValue();
    const initialOffset = options.indexOf(value) * height;

    return (
      <List
        height={maxHeight}
        itemCount={children.length}
        itemSize={height}
        initialScrollOffset={initialOffset}
      >
        {({ index, style }) => <div style={style}>{children[index]}</div>}
      </List>
    );
  }
}

class SearchPanel extends Component {
  state = {
    periodRSelected: 2,
    //modalAddReportWizard: false,
    msg: {},
    confirmDeleteFilesModal: false,
    confirmDeleteFilesChannelsModal: false,
    //selectedReport: '',
    //selectedReportId: '',
    deleteFilesReason: "",
    deleteFilesChannelsReason: "",
  };

  onSearchTextFieldChange = (e) => {
    const { view, handleParamChange } = this.props;
    if (view === "documentsView") {
      handleParamChange("DocumentNumbers", e.target.value);
    } else if (view === "execReportsView" || view === "homeView") {
      handleParamChange("SearchText", e.target.value);
    } else if (view === "configReportsView") {
      handleParamChange("SearchText", e.target.value);
    } else {
      handleParamChange("FileNames", e.target.value);
    }
  };

  onSlaFilterCheckboxChange = (e) => {
    let { SlaFilter } = this.props.searchParams;
    var index;
    let currentValues = (SlaFilter || []).slice(0);
    if (e.target.checked) {
      currentValues.push(e.target.value);
    } else {
      index = currentValues.indexOf(e.target.value);
      if (index !== -1) currentValues.splice(index, 1);
    }
    this.props.handleParamChange("SlaFilter", currentValues);
  };

  onIncludeInactiveCheckboxChange = (e) => {
    let { IncludeInactive } = this.props.searchParams;
    this.props.handleParamChange("IncludeInactive", !IncludeInactive);
    setTimeout(() => {
      this.props.onSearchClick();
    }, 200);
  };

  toggleAdvSearchOptions = () => {
    const { showMoreHeight } = this.props.searchParams;
    if (showMoreHeight === 0) {
      this.props.handleParamChange("moreArrowIcon", "fa-chevron-up");
      this.props.handleParamChange(
        "toggleBtnTitle",
        "Hide advanced search options"
      );
    } else {
      this.props.handleParamChange("moreArrowIcon", "fa-chevron-down");
      this.props.handleParamChange(
        "toggleBtnTitle",
        "Show advanced search options"
      );
    }
    var _showMoreHeight =
      this.props.searchParams.showMoreHeight === 0 ? "auto" : 0;

    this.props.handleParamChange("showMoreHeight", _showMoreHeight);
    this.setState({
      showMoreHeight: showMoreHeight === 0 ? "auto" : 0,
    });
  };

  onSelectedCustomerChange(selectedCustomer) {
    if (selectedCustomer) {
      let _selValue = selectedCustomer.value;
      this.props.handleParamChange("CustomerId", _selValue);
      this.props.handleParamChange("ProjectId", null);
      if (
        this.props.view !== "execReportsView" &&
        this.props.view !== "configReportsView"
      ) {
        this.getProjectsByGlobalId(_selValue);
      }
    } else {
      this.props.handleParamChange("CustomerId", null);
      this.props.handleParamChange("ProjectId", null);
      switch (this.props.view) {
        case "filesView":
          this.props.dispatch(configActions.resetFilesProjectsStores());
          break;
        case "documentsView":
          this.props.dispatch(configActions.resetDocsProjectsStores());
          break;
        case "dashboardView":
          this.props.dispatch(configActions.resetDashboardProjectsStores());
          break;
        default:
          break;
      }
    }
  }

  onPeriodRadioBtnClick = (periodRSelected) => {
    var _to = new Date(),
      _from = new Date();

    switch (periodRSelected) {
      case 1:
        // 7 days ago
        _from.setDate(_from.getDate() - 7);
        break;
      case 2:
        // this month (since the first day of the month)
        _from = new Date(_from.getFullYear(), _from.getMonth(), 1);
        break;
      case 3:
        // one month ago
        _from.setMonth(_from.getMonth() - 1);
        break;
      case 4:
        // one year ago
        _from.setYear(_from.getFullYear() - 1);
        break;
      case 5:
        // 3 months ago
        _from.setMonth(_from.getMonth() - 3);
        break;
      case 6:
        // this year (since the first day of the current year)
        _from = new Date(_from.getFullYear(), 0, 1);
        break;
      default:
        break;
    }
    this.props.handleParamChange("Start", _from);
    this.props.handleParamChange("End", _to);
    setTimeout(() => {
      this.props.onSearchClick();
    }, 200);
  };

  getProjectsByGlobalId = (globalId) => {
    if (globalId) {
      this.props.dispatch(
        configActions.filterProjectByCustomerId(globalId, this.props.view)
      );
    }
  };

  onSelectedProjectChange(selectedProject) {
    if (selectedProject) {
      const {
        config: { customers },
        searchParams: { CustomerId },
      } = this.props;
      if (!CustomerId) {
        let refCustomer = (customers || []).filter((item) => {
          return !!(item.projects || []).filter(
            (proj) => proj.projectId === selectedProject.value
          )[0];
        })[0];
        if (refCustomer) {
          this.props.handleParamChange("CustomerId", refCustomer.globalId);
          this.getProjectsByGlobalId(refCustomer.globalId);
        }
      }
      this.props.handleParamChange("ProjectId", selectedProject.value);
    } else {
      this.props.handleParamChange("ProjectId", "");
    }
  }

  onSelectedChannelChange(selectedChannel) {
    if (selectedChannel) {
      this.props.handleParamChange("ChannelName", selectedChannel.value);
    } else {
      this.props.handleParamChange("ChannelName", "");
    }
  }
  onSelectedStatusChange = (selectedChannel) => {
    if (selectedChannel) {
      this.props.handleParamChange("StatusFilter", selectedChannel.value);
    } else {
      this.props.handleParamChange("StatusFilter", "All");
    }
  };

  onSelectedPlatformChange(selectedChannel) {
    if (selectedChannel) {
      this.props.handleParamChange("Platform", selectedChannel.value);
      if (selectedChannel.value === "All") {
        if (this.props.view === "filesView") {
          this.props.dispatch(configActions.clearFilterFilesViewCustomers());
        } else if (this.props.view === "documentsView") {
          this.props.dispatch(configActions.clearFilterDocsViewCustomers());
        }
      } else {
        let _allCustomers = this.props.config.customers || [];
        let customers = [];
        _allCustomers.forEach((item) => {
          var _legacyids = item.legacyids || [];
          var _included = false;
          for (let i = 0; i < _legacyids.length; i++) {
            const element = _legacyids[i];
            if (element.systemname === selectedChannel.value) {
              _included = true;
              break;
            }
          }
          if (_included) {
            customers.push({ ...item });
          }
        });
        if (this.props.view === "filesView") {
          this.props.dispatch(
            configActions.filterFilesViewCustomers(customers)
          );
        } else if (this.props.view === "documentsView") {
          this.props.dispatch(configActions.filterDocsViewCustomers(customers));
        }
      }
    } else {
      this.props.handleParamChange("Platform", "All");
      if (this.props.view === "filesView") {
        this.props.dispatch(configActions.clearFilterFilesViewCustomers());
      } else if (this.props.view === "documentsView") {
        this.props.dispatch(configActions.clearFilterDocsViewCustomers());
      }
    }
  }

  onCustomerLegacyIdChange(e) {
    this.props.handleParamChange("CustomerLegacyId", e.target.value);
  }

  onTechnicalFlowIdChange(e) {
    this.props.handleParamChange("flowid", e.target.value);
  }

  onSelectedReportTypeChange = (selectedType) => {
    const { view, handleParamChange } = this.props;
    if (selectedType) {
      if (view === "execReportsView") {
        handleParamChange("TemplateId", selectedType.value);
      } else if (view === "configReportsView") {
        handleParamChange("PipelineDefinitionId", selectedType.value);
      }
    } else {
      if (view === "execReportsView") {
        handleParamChange("TemplateId", "");
      } else if (view === "configReportsView") {
        handleParamChange("PipelineDefinitionId", "");
      }
    }
  };

  handleAddReportBtnClick = (event) => {
    event.preventDefault();
    const { dispatch } = this.props;
    dispatch(reportActions.setHandleGridReloadCallBack(null));
    dispatch(reportActions.setWizardSelectedReport(""));
    dispatch(reportActions.toggleModalAddReportWizard(true));
    dispatch(reportActions.setSelectedNewReportCustomer(null));
  };

  toggleMsgBox = () => {
    if (this.state.resetLoader) this.state.resetLoader();
    this.setState({
      msg: {},
      resetLoader: null,
    });
  };

  onRemoveFilesChannelsBtnClick = () => {
    this.setState({
      confirmDeleteFilesChannelsModal: true,
    });
  };

  onRemoveFilesChannelsBtnClick = () => {
    this.setState({
      confirmDeleteFilesChannelsModal: true,
    });
  };

  onRemoveFilesBtnClick = () => {
    this.setState({
      confirmDeleteFilesModal: true,
    });
  };

  onRestartExecReportsBtnClick = () => {
    const { selectedExecReports, dispatch } = this.props;
    if (selectedExecReports && selectedExecReports.length) {
      let params = {
        pipelineIds: selectedExecReports,
      };
      dispatch(loaderMaskActions.show("Restarting pipeline..."));
      var qs = require("qs");
      axios
        .post(
          "reporting/pipelines/batchrestart",
          {},
          {
            params,
            paramsSerializer: function (params) {
              return qs.stringify(params, { arrayFormat: "repeat" });
            },
          }
        )
        .then((response) => {
          var json = response.data;
          dispatch(loaderMaskActions.hide(""));
          if (json.Errors && json.Errors.length) {
            dispatch(msgActions.error("Restart Reports", json.Errors[0]));
            return;
          }
          dispatch(
            msgActions.success(
              "Restart Reports",
              "Reports restarted successfully."
            )
          );
        });
    }
  };

  onRestertAsNewExecReportsBtnClick = () => {
    const { selectedExecReports, dispatch } = this.props;
    if (selectedExecReports && selectedExecReports.length) {
      let params = {
        pipelineIds: selectedExecReports,
      };
      dispatch(loaderMaskActions.show("Restarting pipeline as new..."));
      var qs = require("qs");
      axios
        .post(
          "reporting/pipelines/BatchRestartAsNew",
          {},
          {
            params,
            paramsSerializer: function (params) {
              return qs.stringify(params, { arrayFormat: "repeat" });
            },
          }
        )
        .then((response) => {
          var json = response.data;
          dispatch(loaderMaskActions.hide(""));
          if (json.Errors && json.Errors.length) {
            dispatch(
              msgActions.error("Restart Reports as New", json.Errors[0])
            );
            return;
          }
          dispatch(
            msgActions.success(
              "Restart Reports as New",
              "Reports restarted successfully."
            )
          );
        });
    }
  };

  toggleConfirmDeleteFilesChannelsModal = () => {
    this.setState({
      confirmDeleteFilesChannelsModal:
        !this.state.confirmDeleteFilesChannelsModal,
    });
  };

  toggleConfirmDeleteFilesModal = () => {
    this.setState({
      confirmDeleteFilesModal: !this.state.confirmDeleteFilesModal,
    });
  };

  handleYesConfirmDeleteDialog = () => {
    const { user, subUser, isSubUser, selectedFiles, dispatch, translate } =
      this.props;
    var me = this;
    var currentUser = user;
    if (isSubUser) {
      currentUser = subUser;
    }
    const { userId } = currentUser || {};
    if (selectedFiles && selectedFiles.length) {
      if (
        !this.state.deleteFilesReason ||
        this.state.deleteFilesReason.length < 4
      ) {
        dispatch(
          msgActions.error(
            "Remove Files",
            "Please enter the reason. It should be at least 4 chars long."
          )
        );
        return;
      }
      let _params = {
        FlowIdFileStart: selectedFiles,
        UserName: userId,
        TimeStamp: moment().toISOString(),
        Reason: this.state.deleteFilesReason,
      };
      axios.post("Tracking/RemoveFlow", _params).then((response) => {
        var json = response.data;
        if (json.Errors && json.Errors.length) {
          dispatch(msgActions.error("Remove Files", json.Errors[0]));
          return;
        }
        dispatch(
          msgActions.success("Remove Files", "Files removed successfully.")
        );
        dispatch(
          fileActions.getAll(
            getFilesParams(
              { ...me.props.fileSearch },
              me.props.isExternalUser,
              me.props.externalCustomerId
            ),
            `${translate("LoadingFiles")}...`
          )
        );
      });
    }
  };

  handleYesConfirmDeleteChannelsDialog = () => {
    const {
      user,
      subUser,
      isSubUser,
      selectedFlowIdsChannels,
      dispatch,
      translate,
    } = this.props;
    var me = this;
    var currentUser = user;
    if (isSubUser) {
      currentUser = subUser;
    }
    const { userId } = currentUser || {};
    if (selectedFlowIdsChannels && selectedFlowIdsChannels.length) {
      if (
        !this.state.deleteFilesChannelsReason ||
        this.state.deleteFilesChannelsReason.length < 4
      ) {
        dispatch(
          msgActions.error(
            "Remove Channels",
            "Please enter the reason. It should be at least 4 chars long."
          )
        );
        return;
      }
      let _params = {
        FlowIdsChannelsOperators: selectedFlowIdsChannels,
        UserName: userId,
        TimeStamp: moment().toISOString(),
        Reason: this.state.deleteFilesChannelsReason,
      };
      axios.post("Tracking/removeflowschannels", _params).then((response) => {
        var json = response.data;
        if (json.Errors && json.Errors.length) {
          dispatch(msgActions.error("Remove Channels", json.Errors[0]));
          return;
        }
        dispatch(
          msgActions.success(
            "Remove Channels",
            "Channels removed successfully."
          )
        );
        //dispatch(fileActions.resetChannelFileSelection());
        dispatch(
          fileActions.getAll(
            getFilesParams(
              { ...me.props.fileSearch },
              me.props.isExternalUser,
              me.props.externalCustomerId
            ),
            `${translate("LoadingFiles")}...`
          )
        );
      });
    }
  };

  onReactivateFilesBtnClick = () => {
    const { selectedFiles, dispatch, allFiles, translate } = this.props;
    var me = this;
    if (selectedFiles && selectedFiles.length) {
      let expFileIds = [];
      selectedFiles.forEach((item) => {
        var _file = allFiles.find((x) => x.fidfs === item);
        if (_file && _file.st && _file.st === "exp") expFileIds.push(item);
      });
      let _params = {
        fidFs: expFileIds,
      };
      axios.put("Tracking/activateFilesBuckets", _params).then((response) => {
        var json = response.data;
        if (json.Errors && json.Errors.length) {
          dispatch(msgActions.error("Reactivate Files", json.Errors[0]));
          return;
        }
        dispatch(
          msgActions.success(
            "Reactivate Files",
            "Files reactivated successfully."
          )
        );
        dispatch(
          fileActions.getAll(
            getFilesParams(
              { ...me.props.fileSearch },
              me.props.isExternalUser,
              me.props.externalCustomerId
            ),
            `${translate("LoadingFiles")}...`
          )
        );
      });
    }
  };

  isOldFile = (file) => {
    const arrivalTime = moment
      .utc(file.file.timestamp, moment.ISO_8601)
      .toDate();
    let _activeFileLimitDate = moment.utc().toDate();
    _activeFileLimitDate.setDate(
      _activeFileLimitDate.getDate() - (window.ActiveFileMaxAgeDays || 2)
    );
    return arrivalTime.getTime() < _activeFileLimitDate.getTime();
  };

  atLeastOneFileIsExp = (selectedFiles) => {
    const { allFiles } = this.props;
    if (selectedFiles && selectedFiles.length) {
      var _noExpFile = true;
      selectedFiles.forEach((item) => {
        var _file = allFiles.find((x) => x.fidfs === item);
        if (_file && _file.st && _file.st === "exp" && !this.isOldFile(_file))
          _noExpFile = false;
      });
      return _noExpFile;
    } else return true;
  };

  handleDeleteFilesChannelsReasonChange = (e) => {
    this.setState({
      deleteFilesChannelsReason: e.target.value,
    });
  };

  handleDeleteFilesReasonChange = (e) => {
    this.setState({
      deleteFilesReason: e.target.value,
    });
  };

  onClearSelectionBtnClick = () => {
    const { dispatch } = this.props;
    dispatch(fileActions.resetChannelFileSelection());
    dispatch(fileActions.toggleSelectAll(0));
  };

  onClearExecReportsSelectionBtnClick = () => {
    const { dispatch } = this.props;
    dispatch(reportActions.toggleSelectAll(0));
  };

  navToCustomerSettings = (customerId) => {
    const { dispatch, selCustomerConfigReportsSize, history } = this.props;
    dispatch(configActions.setFilterStr("")); // reset filter
    dispatch(configActions.getProjectsByCustomerId(customerId, "configView"));
    dispatch(
      configActions.getReportsByCustomerId(
        customerId,
        1,
        selCustomerConfigReportsSize
      )
    );
    history.push("/customers");
  };

  toggleSenderIdSetting = (bySenderId) => {
    this.props.handleParamChange("BySenderId", bySenderId);
  };

  toggleWithAndStatuses = (tctIn) => {
    this.props.handleParamChange("TctIn", tctIn);
  };

  toggleReceiverIdSetting = (byReceiverId) => {
    this.props.handleParamChange("ByReceiverId", byReceiverId);
  };

  toggleDocsViewActiveTab = (tab) => {
    this.props.dispatch(configActions.toggleDocsViewActiveTab(tab));
  };
  setDatePeriod = (from, to) => {
    const { dispatch, view } = this.props;
    switch (view) {
      case "filesView":
        dispatch(
          actions.change("fileSearch.Start", from instanceof Date ? from : "")
        );
        dispatch(
          actions.change("fileSearch.End", to instanceof Date ? to : "")
        );
        break;
      case "documentsView":
        dispatch(
          actions.change("docSearch.Start", from instanceof Date ? from : "")
        );
        dispatch(actions.change("docSearch.End", to instanceof Date ? to : ""));
        break;
      case "execReportsView":
        dispatch(
          actions.change(
            "execReportSearch.Start",
            from instanceof Date ? from : ""
          )
        );
        dispatch(
          actions.change("execReportSearch.End", to instanceof Date ? to : "")
        );
        break;
      default:
        break;
    }
  };

  onLastDayBtnClick = () => {
    var _to = moment
        .utc()
        .set({ hour: 23, minute: 59, second: 59, millisecond: 999 })
        .toDate(),
      _from = moment
        .utc()
        .set({ hour: 0, minute: 0, second: 0, millisecond: 0 })
        .toDate();
    this.setDatePeriod(_from, _to);
  };

  onLast7DayBtnClick = () => {
    var _to = moment
        .utc()
        .set({ hour: 23, minute: 59, second: 59, millisecond: 999 })
        .toDate(),
      _from = moment
        .utc()
        .set({ hour: 0, minute: 0, second: 0, millisecond: 0 })
        .toDate();
    _from.setDate(_from.getDate() - 6);
    this.setDatePeriod(_from, _to);
  };

  onLastMonthBtnClick = () => {
    var _to = moment
        .utc()
        .set({ hour: 23, minute: 59, second: 59, millisecond: 999 })
        .toDate(),
      _from = moment
        .utc()
        .set({ hour: 0, minute: 0, second: 0, millisecond: 0 })
        .toDate();
    _from.setMonth(_from.getMonth() - 1);
    _from.setDate(_from.getDate() + 1);
    this.setDatePeriod(_from, _to);
  };

  render() {
    const {
      view,
      config,
      selectedFiles,
      selectedFlowIdsChannels,
      selectedExecReports,
      searchParams,
      isExternalUser,
      externalCustomerId,
      translate,
      tagsOptions,
      isSender,
      user,
      subUser,
      isSubUser,
    } = this.props;

    var currentUser = user;
    if (isSubUser) {
      currentUser = subUser;
    }
    const { language: userLanguage } = currentUser || {};

    let customerOptions = (config.customers || []).map((item) => {
      return { value: item.globalId, label: item.name };
    });
    let channelOptions = (config.channels || []).map((item) => {
      return { value: item, label: item };
    });

    let statusOptions = isExternalUser
      ? [
          { value: "All", label: translate("All") },
          { value: "Delivered", label: translate("Delivered") },
          { value: "InProgress", label: translate("InProgress") },
          { value: "Rejected", label: translate("Rejected") },
        ]
      : [
          { value: "All", label: translate("All") },
          { value: "Delivered", label: translate("Delivered") },
          { value: "InProgress", label: translate("InProgress") },
          { value: "Rejected", label: translate("Rejected") },
          { value: "Removed", label: translate("Removed") },
        ];

    let docStatusOptions = isExternalUser
      ? [
          { value: "All", label: translate("All") },
          { value: "Delivered", label: translate("Delivered") },
          { value: "InProgress", label: translate("InProgress") },
          { value: "Rejected", label: translate("Rejected") },
          { value: "Cancelled", label: translate("Cancelled") },
        ]
      : [
          { value: "All", label: translate("All") },
          { value: "Delivered", label: translate("Delivered") },
          { value: "InProgress", label: translate("InProgress") },
          { value: "Rejected", label: translate("Rejected") },
          { value: "Removed", label: translate("Removed") },
          { value: "Cancelled", label: translate("Cancelled") },
        ];

    let platformOptions = (config.platformNames || [])
      .filter((obj) => {
        return obj.isPlatform;
      })
      .map((item) => {
        return { value: item.platformId, label: item.name };
      });

    platformOptions.unshift({ value: "All", label: "All" });

    let data = {
      title: translate("Search for files"),
      filterPlaceHolder: translate("Search by file name"),
    };

    let projectRefList = [];
    switch (view) {
      case "filesView":
        projectRefList = config.filesViewProjects;
        break;
      case "documentsView":
        projectRefList = config.docsViewProjects;
        break;
      case "configReportsView":
        projectRefList = config.configReportsViewProjects;
        break;
      case "dashboardView":
        projectRefList = config.dashboardViewProjects;
        break;
      default:
        break;
    }

    let projectOptions = (projectRefList || [])
      .map((item) => {
        return { value: item.projectId, label: item.name };
      })
      .sort((a, b) => {
        return a.label > b.label ? 1 : b.label > a.label ? -1 : 0;
      });

    if (searchParams.End === "Invalid date") {
      searchParams.End = "";
    }

    if (view === "documentsView") {
      data = {
        title: translate("Search for documents"),
        filterPlaceHolder: translate("Search by document number"),
      };
    } else if (view === "homeView") {
      data = {
        title: translate("Search for files or documents"),
        filterPlaceHolder: translate(
          "landingPageSearchPlaceholder"
        ),
      };
    } else if (view === "execReportsView") {
      data = {
        title: translate("Search for executed reports"),
        filterPlaceHolder: translate(
          "reportPageSearchPlaceholder"
        ),
      };
    } else if (view === "configReportsView") {
      data = {
        title: "Search for configured reports",
        filterPlaceHolder: translate("reportPageSearchPlaceholder"),
      };
    } else if (view === "dashboardView") {
      data = {
        title: "Filter options",
        filterName: "filter_file",
      };
    }

    const slaStatusOptions = [
      { value: "ok", label: "MET" },
      { value: "breached", label: "BREACHED" },
      { value: "breachwarning", label: "WARNING" },
      { value: "calcfailed", label: "UNKNOWN" },
    ];

    return (
      <>
        <div className="horizSearchForm" name="horizSearchForm">
          <div
            className="search_block1"
            style={view === "homeView" ? {} : { background: "#DAD7CB" }}
          >
            <div
              className={`search_top ${view === "homeView" ? "container" : ""}`}
              style={
                view === "homeView"
                  ? {
                      padding:
                        customerOptions.length && customerOptions.length > 1
                          ? "0.5rem 0 1rem"
                          : "2.5rem 0 1rem",
                    }
                  : { padding: "0.5rem 0 1rem" }
              }
            >
              {view === "homeView" &&
                customerOptions.length &&
                customerOptions.length > 1 && (
                  <div
                    className="d-flex flex-row align-items-center min-to-column mid-width-to-75 disable_height min-width-center search-fields-container"
                    style={{
                      display: "flex",
                      textAlign: "left",
                      margin: "1em 0",
                    }}
                  >
                    <div style={{ padding: "0.5em" }}>
                      {translate("SelectCustomer")}...
                    </div>
                    <div
                      className="input-group min-top-input-borders-set custom2 select-customer-div search_menu_item exec-report-ext-search"
                      style={{ width: "400px" }}
                    >
                      <Select
                        components={{ MenuList }}
                        name="customerComboBox"
                        ref={(input) => {
                          window.TestingDoms["dashboardViewCustomer"] = input;
                        }}
                        className="customerComboBox chosen_static_search w_action_select allow-custom-input form-control customers-landing-select"
                        value={searchParams.CustomerId}
                        disabled={
                          !!searchParams.CustomerLegacyId ||
                          !!this.props.docListFromFileLoaded
                        }
                        searchable={!config.loadingActiveCustomers}
                        isLoading={config.loadingActiveCustomers}
                        loadingPlaceholder="Loading customers..."
                        placeholder={`${
                          config.loadingActiveCustomers
                            ? translate("Loading customers")
                            : translate("SelectCustomer")
                        }...`}
                        onChange={this.onSelectedCustomerChange.bind(this)}
                        options={customerOptions}
                      />
                    </div>
                  </div>
                )}
              <div className="search_title_div d-flex flex-row align-items-center min-to-column mid-width-to-75 disable_height min-width-center custom1">
                {data.title}
              </div>
              <div
                className="d-flex flex-row min-to-column"
                style={view === "homeView" ? {} : { padding: "0 1.8rem" }}
              >
                {view !== "dashboardView" ? (
                  <div className="d-flex flex-row align-items-center min-to-column mid-width-to-75 disable_height min-width-center search-fields-container">
                    <div
                      className="min-width-to-100 mid-width-to-50 search_menu_item input-text-div"
                      style={
                        view === "homeView"
                          ? { width: "100%" }
                          : { width: "45%" }
                      }
                    >
                      <div>
                        <div
                          className={`input-group min-top-input-borders-set custom2 ${
                            (view === "homeView" && isExternalUser) || isSender
                              ? "exec-report-ext-search"
                              : ""
                          }`}
                        >
                          <span
                            className="fa fa-search custom3"
                            aria-hidden="true"
                          />
                          <Input
                            type="text"
                            autoFocus={view === "homeView"}
                            style={{ border: "0px", paddingLeft: ".3rem" }}
                            value={
                              view === "documentsView"
                                ? searchParams.DocumentNumbers
                                : view === "configReportsView"
                                ? searchParams.SearchText
                                : view === "execReportsView" ||
                                  view === "homeView"
                                ? searchParams.SearchText
                                : searchParams.FileNames
                            }
                            placeholder={data.filterPlaceHolder}
                            onChange={this.onSearchTextFieldChange}
                            onPaste={this.props.handleOnPaste}
                          />
                        </div>
                      </div>
                    </div>
                    {view !== "homeView" &&
                      !isSender &&
                      !(isExternalUser && customerOptions.length === 1) && (
                        <>
                          <div className="d-flex align-items-center min-top-hide input-text-split custom4">
                            <div className="custom5" />
                          </div>
                          <div
                            style={{ position: "relative" }}
                            className="text-left min-width-160px min-width-to-100 mid-width-to-50 search_menu_item select-customer-div"
                          >
                            {view === "filesView" ? (
                              <Select
                                name="customerComboBox"
                                components={{ MenuList }}
                                className={
                                  "customerComboBox chosen_static_search w_action_select allow-custom-input form-control" +
                                  (view === "execReportsView" ||
                                  view === "configReportsView"
                                    ? " projectComboBox"
                                    : "") +
                                  (!isExternalUser ? " internal" : "")
                                }
                                value={searchParams.CustomerId}
                                disabled={
                                  !!searchParams.CustomerLegacyId ||
                                  !!this.props.docListFromFileLoaded
                                }
                                searchable={!config.loadingActiveCustomers}
                                isLoading={config.loadingActiveCustomers}
                                loadingPlaceholder="Loading customers..."
                                placeholder={`${
                                  config.loadingActiveCustomers
                                    ? translate("Loading customers")
                                    : translate("SelectCustomer")
                                }...`}
                                onChange={this.onSelectedCustomerChange.bind(
                                  this
                                )}
                                options={(config.filesViewCustomers || []).map(
                                  (item) => {
                                    return {
                                      value: item.globalId,
                                      label: item.name,
                                    };
                                  }
                                )}
                              />
                            ) : view === "documentsView" ? (
                              <Select
                                components={{ MenuList }}
                                name="customerComboBox"
                                className={
                                  "customerComboBox chosen_static_search w_action_select allow-custom-input form-control" +
                                  (view === "execReportsView" ||
                                  view === "configReportsView"
                                    ? " projectComboBox"
                                    : "") +
                                  (!isExternalUser ? " internal" : "")
                                }
                                value={searchParams.CustomerId}
                                disabled={
                                  !!searchParams.CustomerLegacyId ||
                                  !!this.props.docListFromFileLoaded
                                }
                                searchable={!config.loadingActiveCustomers}
                                isLoading={config.loadingActiveCustomers}
                                loadingPlaceholder="Loading customers..."
                                placeholder={`${
                                  config.loadingActiveCustomers
                                    ? translate("Loading customers")
                                    : translate("SelectCustomer")
                                }...`}
                                onChange={this.onSelectedCustomerChange.bind(
                                  this
                                )}
                                options={(config.docsViewCustomers || []).map(
                                  (item) => {
                                    return {
                                      value: item.globalId,
                                      label: item.name,
                                    };
                                  }
                                )}
                              />
                            ) : (
                              <Select
                                name="customerComboBox"
                                components={{ MenuList }}
                                className={
                                  "customerComboBox chosen_static_search w_action_select allow-custom-input form-control" +
                                  (view === "execReportsView" ||
                                  view === "configReportsView"
                                    ? " projectComboBox"
                                    : "") +
                                  (!isExternalUser ? " internal" : "")
                                }
                                value={searchParams.CustomerId}
                                disabled={
                                  !!searchParams.CustomerLegacyId ||
                                  !!this.props.docListFromFileLoaded
                                }
                                searchable={!config.loadingActiveCustomers}
                                isLoading={config.loadingActiveCustomers}
                                loadingPlaceholder="Loading customers..."
                                placeholder={`${
                                  config.loadingActiveCustomers
                                    ? translate("Loading customers")
                                    : translate("SelectCustomer")
                                }...`}
                                onChange={this.onSelectedCustomerChange.bind(
                                  this
                                )}
                                options={customerOptions}
                              />
                            )}
                            {!isExternalUser && (
                              <>
                                {searchParams.CustomerId ? (
                                  <button
                                    type="button"
                                    disabled={
                                      !!searchParams.CustomerLegacyId ||
                                      !!this.props.docListFromFileLoaded
                                    }
                                    className="customer_settings_icon"
                                    onClick={() =>
                                      this.navToCustomerSettings(
                                        searchParams.CustomerId
                                      )
                                    }
                                    data-tip
                                    data-place="bottom"
                                    data-type="info"
                                    data-effect="solid"
                                    data-for="customerSetting"
                                  >
                                    <span
                                      className="fa fa-cog"
                                      style={{ padding: "0 8px 0 5px" }}
                                      aria-hidden="true"
                                    />
                                  </button>
                                ) : (
                                  <button
                                    type="button"
                                    disabled={
                                      !!searchParams.CustomerLegacyId ||
                                      !!this.props.docListFromFileLoaded
                                    }
                                    className="customer_settings_icon no-selection"
                                    onClick={(e) => e.preventDefault()}
                                    data-tip
                                    data-place="bottom"
                                    data-type="info"
                                    data-effect="solid"
                                    data-for="noCustomerSelected"
                                  >
                                    <span
                                      className="fa fa-cog"
                                      style={{ padding: "0 8px 0 5px" }}
                                      aria-hidden="true"
                                    />
                                  </button>
                                )}

                                {searchParams.CustomerId ? (
                                  <ReactTooltip
                                    className="customeTheme"
                                    id="customerSetting"
                                  >
                                    <strong>
                                      {translate("Configure customer")}
                                    </strong>
                                  </ReactTooltip>
                                ) : (
                                  <ReactTooltip
                                    className="customeTheme"
                                    id="noCustomerSelected"
                                  >
                                    <strong>
                                      {translate("Choose customer first")}
                                    </strong>
                                  </ReactTooltip>
                                )}
                              </>
                            )}
                          </div>
                        </>
                      )}
                    {view !== "execReportsView" &&
                      view !== "homeView" &&
                      view !== "configReportsView" &&
                      !isSender && [
                        <div
                          key="select-proj-icon"
                          className="d-flex align-items-center min-top-hide select-flow-split custom6"
                        >
                          <div className="custom7" />
                        </div>,
                        <div
                          key="select-proj-select"
                          className="text-left min-width-160px min-width-to-100 mid-width-to-50 search_menu_item select-flow"
                        >
                          <Select
                            name="projectComboBox"
                            ref={(input) => {
                              if (view === "documentsView") {
                                window.TestingDoms["docsViewProject"] = input;
                              } else {
                                window.TestingDoms["filesViewProject"] = input;
                              }
                            }}
                            className="projectComboBox chosen_static_search w_action_select allow-custom-input form-control"
                            disabled={
                              !!searchParams.CustomerLegacyId ||
                              !!this.props.docListFromFileLoaded
                            }
                            value={searchParams.ProjectId}
                            placeholder={`${translate("SelectFlow")}...`}
                            onChange={this.onSelectedProjectChange.bind(this)}
                            options={projectOptions}
                          />
                        </div>,
                      ]}
                    <div className="search_menu_item mid-width-to-50 search-btn-div">
                      <div
                        className="text-center main-button-container"
                        style={{ display: "flex" }}
                      >
                        <Button
                          color="primary"
                          type="submit"
                          disabled={
                            view === "homeView" && !searchParams.SearchText
                          }
                          className={
                            view === "homeView" && !searchParams.SearchText
                              ? "btn-posti-default disabled"
                              : "btn-posti-default"
                          }
                          onClick={(e) => {
                            e.preventDefault();
                            if (
                              view !== "homeView" ||
                              !!searchParams.SearchText
                            ) {
                              const _indx =
                                window.tooltipAlreadyShown.indexOf(
                                  "DownloadBtn"
                                );
                              if (_indx > -1) {
                                window.tooltipAlreadyShown.splice(_indx, 1);
                              }
                              this.props.onSearchClick();
                            }
                          }}
                        >
                          <span>{translate("Search")}</span>
                        </Button>
                        {!isMobile && (
                          <QuickDownloadButton
                            view={view}
                            isExternalUser={isExternalUser}
                            externalCustomerId={externalCustomerId}
                            isSender={isSender}
                          />
                        )}

                        <Button
                          onClick={this.toggleAdvSearchOptions}
                          type="button"
                          className="btn w_action ls-screen-hidden"
                          data-action="more_block"
                          aria-label="Left Align"
                        >
                          <span
                            className={"fa " + searchParams.moreArrowIcon}
                            aria-hidden="true"
                          />
                        </Button>
                        {view === "configReportsView" && (
                          <Button
                            type="button"
                            className="ls-screen-hidden"
                            color="primary"
                            onClick={this.handleAddReportBtnClick}
                          >
                            <span
                              className={"fa fa-file-alt"}
                              style={{ paddingRight: ".5rem" }}
                              aria-hidden="true"
                            />
                            <span>{translate("AddReport")}</span>
                          </Button>
                        )}
                      </div>
                    </div>
                    {view === "configReportsView" && !isExternalUser && (
                      <div
                        style={{ marginLeft: "0.5em" }}
                        className="text-left box hidden-sm-screen"
                      >
                        <Input
                          defaultChecked={searchParams.IncludeInactive}
                          type="checkbox"
                          id="IncludeInactive"
                          value={false}
                          onChange={this.onIncludeInactiveCheckboxChange.bind(
                            this
                          )}
                        />
                        <Label
                          htmlFor="IncludeInactive"
                          className="form-check-label"
                        >
                          {translate("IncludeInactive")}
                        </Label>
                      </div>
                    )}
                  </div>
                ) : (
                  <div className="d-flex flex-row align-items-center min-to-column mid-width-to-75 disable_height min-width-center search-fields-container">
                    {!isExternalUser && (
                      <div
                        style={{ position: "relative" }}
                        className="external_hide text-left min-width-160px min-width-to-100 mid-width-to-50 search_menu_item select-customer-div"
                      >
                        <Select
                          components={{ MenuList }}
                          name="customerComboBox"
                          ref={(input) => {
                            window.TestingDoms["dashboardViewCustomer"] = input;
                          }}
                          className={
                            "customerComboBox chosen_static_search w_action_select allow-custom-input form-control input-text-div" +
                            (!isExternalUser ? " internal" : "")
                          }
                          value={searchParams.CustomerId}
                          disabled={
                            !!searchParams.CustomerLegacyId ||
                            !!this.props.docListFromFileLoaded
                          }
                          searchable={!config.loadingActiveCustomers}
                          isLoading={config.loadingActiveCustomers}
                          loadingPlaceholder="Loading customers..."
                          placeholder={`${
                            config.loadingActiveCustomers
                              ? translate("Loading customers")
                              : translate("SelectCustomer")
                          }...`}
                          onChange={this.onSelectedCustomerChange.bind(this)}
                          options={customerOptions}
                        />
                        {searchParams.CustomerId ? (
                          <button
                            type="button"
                            className="customer_settings_icon"
                            onClick={() =>
                              this.navToCustomerSettings(
                                searchParams.CustomerId
                              )
                            }
                            data-tip
                            data-place="bottom"
                            data-type="info"
                            data-effect="solid"
                            data-for="customerSetting"
                          >
                            <span
                              className="fa fa-cog"
                              style={{ padding: "0 8px 0 5px" }}
                              aria-hidden="true"
                            />
                          </button>
                        ) : (
                          <button
                            type="button"
                            className="customer_settings_icon no-selection"
                            onClick={(e) => e.preventDefault()}
                            data-tip
                            data-place="bottom"
                            data-type="info"
                            data-effect="solid"
                            data-for="noCustomerSelected"
                          >
                            <span
                              className="fa fa-cog"
                              style={{ padding: "0 8px 0 5px" }}
                              aria-hidden="true"
                            />
                          </button>
                        )}

                        {searchParams.CustomerId ? (
                          <ReactTooltip
                            className="customeTheme"
                            id="customerSetting"
                          >
                            <strong>{translate("Configure customer")}</strong>
                          </ReactTooltip>
                        ) : (
                          <ReactTooltip
                            className="customeTheme"
                            id="noCustomerSelected"
                          >
                            <strong>
                              {translate("Choose customer first")}
                            </strong>
                          </ReactTooltip>
                        )}
                      </div>
                    )}
                    <div className="d-flex align-items-center min-top-hide select-flow-split custom6">
                      <div className="custom7" />
                    </div>
                    <div className="text-left min-width-160px min-width-to-100 mid-width-to-50 search_menu_item select-flow">
                      <Select
                        name="projectComboBox"
                        ref={(input) => {
                          window.TestingDoms["dashboardViewProject"] = input;
                        }}
                        className="projectComboBox chosen_static_search w_action_select allow-custom-input form-control"
                        disabled={
                          !!searchParams.CustomerLegacyId ||
                          !!this.props.docListFromFileLoaded
                        }
                        value={searchParams.ProjectId}
                        placeholder={`${translate("SelectFlow")}...`}
                        onChange={this.onSelectedProjectChange.bind(this)}
                        options={projectOptions}
                      />
                    </div>
                    <div
                      className="dashboard-period d-flex min-width-to-100"
                      style={{ padding: "0 10px" }}
                    >
                      <Datetime
                        value={searchParams.Start}
                        utc={true}
                        locale={getMomentLocaleByLang(userLanguage)}
                        dateFormat="DD-MM-YYYY"
                        timeFormat="HH:mm"
                        inputProps={{
                          placeholder: "dd-MM-yyyy HH:mm",
                          className:
                            "min-width-to-100 mid-width-to-50 search_menu_item input-text-div custom2 --date-picker-custom",
                        }}
                        onChange={(Start) => {
                          const _date = moment(Start).toDate();
                          this.props.dispatch(
                            actions.change(
                              "dashboardSearch.Start",
                              _date instanceof Date ? _date : ""
                            )
                          );
                        }}
                      />
                      <div className="d-flex align-items-center min-top-hide select-flow-split custom6">
                        <div className="custom7" />
                      </div>
                      <Datetime
                        value={searchParams.End}
                        utc={true}
                        locale={getMomentLocaleByLang(userLanguage)}
                        dateFormat="DD-MM-YYYY"
                        timeFormat="HH:mm"
                        inputProps={{
                          placeholder: "dd-MM-yyyy HH:mm",
                          className:
                            "min-width-to-100 mid-width-to-50 search_menu_item input-text-div custom2 dash-period-to --date-picker-custom",
                        }}
                        onChange={(End) => {
                          const _date = moment(End).toDate();
                          this.props.dispatch(
                            actions.change(
                              "dashboardSearch.End",
                              _date instanceof Date ? _date : ""
                            )
                          );
                        }}
                      />
                    </div>
                    <div className="search_menu_item mid-width-to-50 search-btn-div">
                      <div className="text-center main-button-container">
                        <Button
                          type="submit"
                          data-loading-text="Loading..."
                          color="primary"
                          className="btn-posti-default"
                          onClick={(e) => {
                            e.preventDefault();
                            this.props.onSearchClick();
                          }}
                        >
                          <span>{translate("Search")}</span>
                        </Button>
                        <Button
                          onClick={this.toggleAdvSearchOptions}
                          type="button"
                          className="btn w_action ls-screen-hidden"
                          data-action="more_block"
                          aria-label="Left Align"
                        >
                          <span
                            className={"fa " + searchParams.moreArrowIcon}
                            aria-hidden="true"
                          />
                        </Button>
                      </div>
                    </div>
                  </div>
                )}
                {view !== "homeView" &&
                  (view !== "configReportsView" || !isExternalUser) && (
                    <div className="text-right min-padding-set3 search-top-advanced-calc hidden-sm-screen">
                      <Button
                        onClick={this.toggleAdvSearchOptions}
                        type="button"
                        className="btn w_action eventSearchMore"
                        data-action="more_block"
                        aria-label="Left Align"
                      >
                        <span
                          className={"fa " + searchParams.moreArrowIcon}
                          style={{ paddingRight: ".5rem" }}
                          aria-hidden="true"
                        />
                        <span>{translate(searchParams.toggleBtnTitle)}</span>
                      </Button>
                    </div>
                  )}
                {view === "configReportsView" && (
                  <div className="text-right min-padding-set3 search-top-advanced-calc hidden-sm-screen">
                    <Button
                      type="button"
                      color="primary"
                      onClick={this.handleAddReportBtnClick}
                    >
                      <span
                        className={"fa fa-file-alt"}
                        style={{ paddingRight: ".5rem" }}
                        aria-hidden="true"
                      />
                      <span>{translate("AddReport")}</span>
                    </Button>
                  </div>
                )}
              </div>
              {view === "filesView" &&
                !isExternalUser &&
                !!selectedFiles &&
                (selectedFiles.length > 0 ||
                  selectedFlowIdsChannels.length > 0) && (
                  <div className="col-lg-12 col-md-12 col-sm-12 col-12">
                    <div className="row">
                      <div className="col-lg-12 col-md-12 col-sm-12 col-sm-12 col-12">
                        <div
                          className="row top_more_style"
                          style={{ marginTop: ".5rem", marginLeft: 0 }}
                        >
                          <div
                            className="form-group col-xl-4 col-lg-4 col-md-6 col-sm-12 col-24"
                            style={{ maxWidth: "450px", margin: 0 }}
                          >
                            {" "}
                            <div style={{ padding: "0.4rem", float: "left" }}>
                              {selectedFiles && selectedFiles.length
                                ? selectedFiles.length
                                : 0}
                              {selectedFiles && selectedFiles.length === 1
                                ? " " + translate("file selected")
                                : " " + translate("files selected")}
                            </div>
                            <ButtonGroup>
                              <Button
                                size="sm"
                                color="primary"
                                onClick={() => this.onRemoveFilesBtnClick()}
                                disabled={
                                  selectedFiles && selectedFiles.length
                                    ? false
                                    : true
                                }
                              >
                                {translate("Remove files")}
                              </Button>
                              <Button
                                size="sm"
                                color="primary"
                                onClick={() =>
                                  this.onRemoveFilesChannelsBtnClick()
                                }
                                disabled={
                                  selectedFlowIdsChannels &&
                                  selectedFlowIdsChannels.length
                                    ? false
                                    : true
                                }
                              >
                                {translate("Remove channels")}
                              </Button>
                              <Button
                                size="sm"
                                color="primary"
                                onClick={() => this.onReactivateFilesBtnClick()}
                                disabled={this.atLeastOneFileIsExp(
                                  selectedFiles
                                )}
                              >
                                {translate("Reactivate files")}
                              </Button>
                              <Button
                                size="sm"
                                onClick={() => this.onClearSelectionBtnClick()}
                              >
                                {translate("Clear selection")}
                              </Button>
                            </ButtonGroup>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )}

              {view === "execReportsView" &&
                !isExternalUser &&
                !!selectedExecReports &&
                selectedExecReports.length > 0 && (
                  <div className="col-lg-12 col-md-12 col-sm-12 col-12">
                    <div className="row">
                      <div className="col-lg-12 col-md-12 col-sm-12 col-sm-12 col-12">
                        <div
                          className="row top_more_style"
                          style={{ marginTop: ".5rem", marginLeft: 0 }}
                        >
                          <div
                            className="form-group col-xl-6 col-lg-6 col-md-12 col-sm-12 col-24"
                            style={{ margin: 0 }}
                          >
                            {" "}
                            <div style={{ padding: "0.4rem", float: "left" }}>
                              {selectedExecReports && selectedExecReports.length
                                ? selectedExecReports.length
                                : 0}
                              {selectedExecReports &&
                              selectedExecReports.length === 1
                                ? " item"
                                : " items"}{" "}
                              selected
                            </div>
                            <ButtonGroup>
                              <Button
                                size="sm"
                                color="primary"
                                onClick={() =>
                                  this.onRestartExecReportsBtnClick()
                                }
                                disabled={
                                  selectedExecReports &&
                                  selectedExecReports.length
                                    ? false
                                    : true
                                }
                              >
                                Restart
                              </Button>
                              <Button
                                size="sm"
                                color="primary"
                                onClick={() =>
                                  this.onRestertAsNewExecReportsBtnClick()
                                }
                                disabled={
                                  selectedExecReports &&
                                  selectedExecReports.length
                                    ? false
                                    : true
                                }
                              >
                                Restart as new
                              </Button>
                              <Button
                                size="sm"
                                onClick={() =>
                                  this.onClearExecReportsSelectionBtnClick()
                                }
                                disabled={
                                  selectedExecReports &&
                                  selectedExecReports.length
                                    ? false
                                    : true
                                }
                              >
                                {translate("Clear selection")}
                              </Button>
                            </ButtonGroup>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
            </div>
            <AnimateHeight
              className="search_bottom"
              duration={500}
              height={searchParams.showMoreHeight}
            >
              {view === "filesView" && (
                <div className="col-lg-12 col-md-12 col-sm-12 col-12">
                  <div
                    className="row"
                    style={{ borderBottom: "solid 1px #CCCCCC" }}
                  >
                    <div className="col-lg-12 col-md-12 col-sm-12 col-sm-12 col-12">
                      <div
                        className="row justify-content-center top_more_style"
                        style={{ marginTop: ".5rem", marginBottom: ".5rem" }}
                      >
                        <div className="form-group col-xl-2 col-lg-2 col-md-4 col-sm-6 col-12 external_hide custom8">
                          <fieldset>
                            <Label
                              style={{
                                marginBottom: "0.2rem",
                                fontSize: "0.8rem",
                                fontWeight: "700",
                              }}
                            >
                              {translate("Status")}
                            </Label>
                            <div style={{ textAlign: "left" }}>
                              <Select
                                name="statusComboBox"
                                className="channelComboBox chosen_static_search w_action_select allow-custom-input form-control min-width-to-100"
                                value={searchParams.StatusFilter || "All"}
                                placeholder={`${translate("Status")}...`}
                                onChange={this.onSelectedStatusChange}
                                options={statusOptions}
                                clearable={false}
                              />
                            </div>
                            {!!isExternalUser ? (
                              <div
                                style={{
                                  margin: "0.8em 2em",
                                  textAlign: "left",
                                }}
                              >
                                <Input
                                  className="form-check-input"
                                  type="checkbox"
                                  defaultChecked={searchParams.hasbbs}
                                  id="hasbbsFilesExt"
                                  onChange={(e) =>
                                    this.props.handleParamChange(
                                      "hasbbs",
                                      e.target.checked
                                    )
                                  }
                                />
                                <Label
                                  htmlFor="hasbbsFilesExt"
                                  className="form-check-label"
                                >
                                  {translate("ShowOnlyFilesBouncebacks")}
                                </Label>
                              </div>
                            ) : (
                              <div
                                className="col-lg-12 col-md-12 col-sm-12 form-group"
                                style={{
                                  padding: 0,
                                  marginBottom: ".2em",
                                  marginTop: ".2em",
                                }}
                              >
                                <Label
                                  htmlFor="filter_batch_id"
                                  style={{
                                    lineHeight: "2px",
                                    fontWeight: "700",
                                  }}
                                >
                                  {translate("SLA Status")}
                                </Label>
                                <div style={{ textAlign: "left" }}>
                                  <Select
                                    value={searchParams.SlaFilter}
                                    multi={true}
                                    placeholder={`${translate(
                                      "SLA Status"
                                    )}...`}
                                    name="SlaFilter"
                                    options={slaStatusOptions}
                                    className="channelComboBox multiselect-status chosen_static_search w_action_select allow-custom-input form-control min-width-to-100"
                                    onChange={(value) => {
                                      const values = (value || []).map(
                                        (item) => item.value
                                      );
                                      this.props.handleParamChange(
                                        "SlaFilter",
                                        values
                                      );
                                    }}
                                  />
                                </div>
                              </div>
                            )}
                          </fieldset>
                        </div>
                        {!isExternalUser && (
                          <div className="form-group col-xl-2 col-lg-2 col-md-4 col-sm-6 col-12 custom8">
                            <fieldset style={{ paddingBottom: "0.5rem" }}>
                              <div
                                hidden={isExternalUser}
                                className="col-lg-12 col-md-12 col-sm-12 pb-1"
                                style={{
                                  padding: 0,
                                  marginBottom: ".4rem",
                                }}
                              >
                                <Label
                                  htmlFor="technical_flow_id"
                                  style={{
                                    lineHeight: "4px",
                                    fontWeight: "700",
                                    paddingTop: "0.375rem",
                                  }}
                                >
                                  {translate("TechnicalFlowID")}
                                  <button
                                    className="tooltip-btn"
                                    data-tip
                                    data-place="bottom"
                                    data-type="info"
                                    data-effect="solid"
                                    data-for="technical_flow_id-ipost"
                                  >
                                    <i
                                      className="fa fa-exclamation-circle"
                                      style={{
                                        padding: "0px 7px 0px",
                                        fontSize: "0.8em",
                                      }}
                                    />
                                  </button>
                                  <ReactTooltip
                                    className="customeTheme"
                                    id="technical_flow_id-ipost"
                                  >
                                    <div style={{ padding: "0.5em 0" }}>
                                      {translate("FlowIDWithPlatform")}
                                    </div>
                                  </ReactTooltip>
                                </Label>
                                <Input
                                  type="text"
                                  disabled={
                                    !searchParams.Platform ||
                                    searchParams.Platform === "All"
                                  }
                                  name="technical_flow_id"
                                  defaultValue={searchParams.flowid}
                                  onChange={this.onTechnicalFlowIdChange.bind(
                                    this
                                  )}
                                  placeholder="Flow ID"
                                  className="form-control"
                                  data-action="flowid"
                                  style={{
                                    lineHeight: "6px",
                                    border: "1px solid #808080",
                                  }}
                                />
                              </div>
                              <Label
                                style={{
                                  marginBottom: "0.2rem",
                                  fontSize: "0.8rem",
                                  fontWeight: "700",
                                }}
                              >
                                {translate("Platform")}
                              </Label>
                              <div style={{ textAlign: "left" }}>
                                <Select
                                  name="platformComboBox"
                                  className="channelComboBox chosen_static_search w_action_select allow-custom-input form-control min-width-to-100"
                                  value={searchParams.Platform || "All"}
                                  placeholder={`${translate("Platform")}...`}
                                  onChange={this.onSelectedPlatformChange.bind(
                                    this
                                  )}
                                  options={platformOptions}
                                  clearable={false}
                                />
                              </div>
                            </fieldset>
                          </div>
                        )}
                        <div className="form-group col-xl-2 col-lg-2 col-md-4 col-sm-6 col-12 custom8">
                          <fieldset>
                            <legend
                              className="col-form-legend"
                              style={{
                                fontSize: ".8rem",
                                marginBottom: "0.5em",
                                fontWeight: "700",
                              }}
                            >
                              {translate("Mode")}
                            </legend>
                            <div
                              className="text-left box"
                              style={{ paddingBottom: ".1rem" }}
                            >
                              <Input
                                type="radio"
                                className="form-check-input"
                                name="statusRadio2"
                                id="StatusRadio2AMode"
                                value=""
                                ref={(input) => {
                                  if (view === "documentsView") {
                                    window.TestingDoms["docsViewModeRadio2A"] =
                                      input;
                                  } else {
                                    window.TestingDoms["filesViewModeRadio2A"] =
                                      input;
                                  }
                                }}
                                defaultChecked={searchParams.Run === ""}
                                onChange={(e) =>
                                  this.props.handleParamChange("Run", "")
                                }
                              />
                              <Label
                                htmlFor="StatusRadio2AMode"
                                className="form-check-label"
                              >
                                {translate("All")}
                              </Label>
                            </div>
                            <div
                              className="text-left box"
                              style={{ paddingBottom: ".1rem" }}
                            >
                              <Input
                                type="radio"
                                className="form-check-input"
                                name="statusRadio2"
                                id="StatusRadio2T"
                                value="t"
                                ref={(input) => {
                                  if (view === "documentsView") {
                                    window.TestingDoms["docsViewModeRadio2T"] =
                                      input;
                                  } else {
                                    window.TestingDoms["filesViewModeRadio2T"] =
                                      input;
                                  }
                                }}
                                defaultChecked={searchParams.Run === "t"}
                                onChange={(e) =>
                                  this.props.handleParamChange("Run", "t")
                                }
                              />
                              <Label
                                htmlFor="StatusRadio2T"
                                className="form-check-label"
                              >
                                {translate("Test")}
                              </Label>
                            </div>
                            <div
                              className="text-left box"
                              style={{ paddingBottom: ".1rem" }}
                            >
                              <Input
                                type="radio"
                                className="form-check-input"
                                name="statusRadio2"
                                id="StatusRadio2TP"
                                value="p"
                                ref={(input) => {
                                  if (view === "documentsView") {
                                    window.TestingDoms["docsViewModeRadio2TP"] =
                                      input;
                                  } else {
                                    window.TestingDoms[
                                      "filesViewModeRadio2TP"
                                    ] = input;
                                  }
                                }}
                                defaultChecked={searchParams.Run === "p"}
                                onChange={(e) =>
                                  this.props.handleParamChange("Run", "p")
                                }
                              />
                              <Label
                                htmlFor="StatusRadio2TP"
                                className="form-check-label"
                              >
                                {translate("Production")}
                              </Label>
                            </div>
                          </fieldset>
                          <div
                            hidden={isExternalUser}
                            className="text-left box external_hide"
                            style={{ margin: "0.3em 0" }}
                          >
                            <p>
                              <Input
                                className="form-check-input"
                                type="checkbox"
                                defaultChecked={searchParams.ErrorFilter}
                                ref={(input) => {
                                  if (view === "documentsView") {
                                    window.TestingDoms[
                                      "docsViewErrorsAndIncidents"
                                    ] = input;
                                  } else {
                                    window.TestingDoms[
                                      "filesViewErrorsAndIncidents"
                                    ] = input;
                                  }
                                }}
                                id="ErrorsAndIncidents"
                                onChange={(e) =>
                                  this.props.handleParamChange(
                                    "ErrorFilter",
                                    e.target.checked
                                  )
                                }
                              />
                              <Label
                                htmlFor="ErrorsAndIncidents"
                                className="form-check-label"
                              >
                                {translate("OnlyErrors")}
                              </Label>
                            </p>
                            <p>
                              <Input
                                className="form-check-input"
                                type="checkbox"
                                defaultChecked={searchParams.ExpFilter}
                                id="ExpFilter"
                                onChange={(e) =>
                                  this.props.handleParamChange(
                                    "ExpFilter",
                                    e.target.checked
                                  )
                                }
                              />
                              <Label
                                htmlFor="ExpFilter"
                                className="form-check-label"
                              >
                                {translate("Show only expired files")}
                              </Label>
                            </p>
                            <p>
                              <Input
                                className="form-check-input"
                                type="checkbox"
                                defaultChecked={searchParams.hasbbs}
                                id="hasbbsFiles"
                                onChange={(e) =>
                                  this.props.handleParamChange(
                                    "hasbbs",
                                    e.target.checked
                                  )
                                }
                              />
                              <Label
                                htmlFor="hasbbsFiles"
                                className="form-check-label"
                              >
                                {translate("ShowOnlyFilesBouncebacks")}
                              </Label>
                            </p>
                          </div>
                        </div>
                        <div className="form-group col-xl-2 col-lg-2 col-md-3 col-sm-6 col-12 custom8">
                          <fieldset className="">
                            <div
                              hidden={isExternalUser}
                              className="col-lg-12 col-md-12 col-sm-12 pb-1"
                              style={{
                                padding: 0,
                                marginBottom: ".4rem",
                              }}
                            >
                              <Label
                                htmlFor="filter_legacy_id"
                                style={{
                                  lineHeight: "4px",
                                  fontWeight: "700",
                                  paddingTop: "0.375rem",
                                }}
                              >
                                {translate("Customer Legacy ID")}
                              </Label>
                              <Input
                                type="text"
                                name="filter_legacy_id"
                                defaultValue={searchParams.CustomerLegacyId}
                                onChange={this.onCustomerLegacyIdChange.bind(
                                  this
                                )}
                                placeholder="ID"
                                className="form-control"
                                data-action="legacyId"
                                style={{
                                  lineHeight: "6px",
                                  border: "1px solid #808080",
                                }}
                              />
                            </div>
                            <div
                              className="col-lg-12 col-md-12 col-sm-12 form-group w_chosen external_hide"
                              style={{
                                padding: 0,
                                marginBottom: ".4rem",
                              }}
                            >
                              <Label
                                style={{ lineHeight: "4px", fontWeight: "700" }}
                              >
                                {translate("Channel")}
                              </Label>
                              <div style={{ textAlign: "left" }}>
                                <Select
                                  name="channelComboBox"
                                  className="channelComboBox chosen_static_search w_action_select allow-custom-input form-control min-width-to-100"
                                  value={searchParams.ChannelName}
                                  placeholder={`${translate(
                                    "SelectChannel"
                                  )}...`}
                                  onChange={this.onSelectedChannelChange.bind(
                                    this
                                  )}
                                  options={channelOptions}
                                />
                              </div>
                            </div>
                          </fieldset>
                        </div>
                        <div
                          className="form-group col-xl-2 col-lg-2 col-md-3 col-sm-6 col-12 custom8"
                          style={{ minHeight: 125 }}
                        >
                          <fieldset style={{ height: "100%" }}>
                            <div
                              className="form-group col-lg-12 col-md-12 col-sm-12"
                              style={{
                                display: "flex",
                                flexDirection: "column",
                                padding: 0,
                                height: "100%",
                              }}
                            >
                              <Label
                                htmlFor="periodTime"
                                className="col-form-label"
                                style={{
                                  lineHeight: "4px",
                                  fontWeight: "700",
                                  paddingTop: "0.375rem",
                                }}
                              >
                                {translate("TimePeriod")}
                              </Label>
                              <div
                                className="text-left"
                                style={{
                                  display: "flex",
                                  flexDirection: "column",
                                }}
                              >
                                <div className="datetime-filter">
                                  <Label
                                    htmlFor="startDate"
                                    style={{
                                      padding: "0.6em",
                                      fontWeight: "600",
                                      margin: 0,
                                      width: "55px",
                                      textAlign: "left",
                                    }}
                                  >
                                    {translate("From")}
                                  </Label>
                                  <Datetime
                                    value={searchParams.Start}
                                    utc={true}
                                    locale={getMomentLocaleByLang(userLanguage)}
                                    dateFormat="DD-MM-YYYY"
                                    timeFormat="HH:mm"
                                    inputProps={{
                                      placeholder: "dd-MM-yyyy HH:mm",
                                      className:
                                        "--date-picker-custom form-control",
                                    }}
                                    onChange={(Start) => {
                                      const _date = moment(Start).toDate();
                                      this.props.dispatch(
                                        actions.change(
                                          "fileSearch.Start",
                                          _date instanceof Date ? _date : ""
                                        )
                                      );
                                    }}
                                  />
                                </div>
                                <div className="datetime-filter">
                                  <Label
                                    htmlFor="endDate"
                                    style={{
                                      padding: "0.6em",
                                      fontWeight: "600",
                                      margin: 0,
                                      width: "55px",
                                      textAlign: "left",
                                    }}
                                  >
                                    {translate("Till")}
                                  </Label>
                                  <Datetime
                                    value={searchParams.End}
                                    utc={true}
                                    locale={getMomentLocaleByLang(userLanguage)}
                                    dateFormat="DD-MM-YYYY"
                                    timeFormat="HH:mm"
                                    inputProps={{
                                      placeholder: "dd-MM-yyyy HH:mm",
                                      className:
                                        "--date-picker-custom datetime-filter form-control",
                                    }}
                                    onChange={(End) => {
                                      const _date = moment(End).toDate();
                                      this.props.dispatch(
                                        actions.change(
                                          "fileSearch.End",
                                          _date instanceof Date ? _date : ""
                                        )
                                      );
                                    }}
                                  />
                                </div>
                              </div>
                              <div
                                className="container time-period-btns"
                                style={{
                                  width: "fit-content",
                                  marginTop: "1em",
                                }}
                              >
                                <Row>
                                  <Col style={{ padding: 0 }}>
                                    <button
                                      type="button"
                                      className="btn btn-primary btn-sm"
                                      onClick={this.onLastDayBtnClick}
                                    >
                                      {translate("LastDay")}
                                    </button>
                                  </Col>
                                  <Col style={{ padding: 0 }}>
                                    <button
                                      type="button"
                                      className="btn btn-primary btn-sm"
                                      onClick={this.onLast7DayBtnClick}
                                    >
                                      {translate("Last 7 days")}
                                    </button>
                                  </Col>
                                  <Col style={{ padding: 0 }}>
                                    <button
                                      type="button"
                                      className="btn btn-primary btn-sm"
                                      onClick={this.onLastMonthBtnClick}
                                    >
                                      {translate("Last Month")}
                                    </button>
                                  </Col>
                                </Row>
                              </div>
                            </div>
                          </fieldset>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}
              {view === "documentsView" && (
                <div className="col-lg-12 col-md-12 col-sm-12 col-12">
                  <div
                    className="row"
                    style={{ borderBottom: "solid 1px #CCCCCC" }}
                  >
                    {isExternalUser ? (
                      <div className="col-lg-12 col-md-12 col-sm-12 col-sm-12 col-12">
                        <div
                          className="row justify-content-center top_more_style"
                          style={{
                            marginTop: ".5rem",
                            marginBottom: ".5rem",
                            marginLeft: "70px",
                            marginRight: "70px",
                          }}
                        >
                          <div className="form-group col-xl-2 col-lg-2 col-md-4 col-sm-6 col-12 custom8">
                            <fieldset style={{ paddingBottom: "0.5rem" }}>
                              <Label
                                style={{
                                  marginBottom: "0.2rem",
                                  fontSize: "0.8rem",
                                  fontWeight: "700",
                                }}
                              >
                                {translate("Status")}
                              </Label>
                              <div style={{ textAlign: "left" }}>
                                <Select
                                  name="statusComboBox"
                                  className="channelComboBox chosen_static_search w_action_select allow-custom-input form-control min-width-to-100"
                                  value={searchParams.DocStatus || "All"}
                                  placeholder={`${translate("Status")}...`}
                                  onChange={(selected) => {
                                    if (selected) {
                                      this.props.handleParamChange(
                                        "DocStatus",
                                        selected.value
                                      );
                                    } else {
                                      this.props.handleParamChange(
                                        "DocStatus",
                                        "All"
                                      );
                                    }
                                  }}
                                  options={docStatusOptions}
                                  clearable={false}
                                />
                                {!!isExternalUser && (
                                  <div style={{ margin: "0.8em 0 0 2em" }}>
                                    <Input
                                      className="form-check-input"
                                      type="checkbox"
                                      defaultChecked={searchParams.hasbbs}
                                      id="hasbbsDocumentsExt"
                                      onChange={(e) =>
                                        this.props.handleParamChange(
                                          "hasbbs",
                                          e.target.checked
                                        )
                                      }
                                    />
                                    <Label
                                      htmlFor="hasbbsDocumentsExt"
                                      className="form-check-label"
                                    >
                                      {translate(
                                        "ShowOnlyDocumentsBouncebacks"
                                      )}
                                    </Label>
                                  </div>
                                )}
                              </div>
                            </fieldset>
                          </div>
                          <div
                            hidden={isSender}
                            className="form-group col-xl col-lg-2 col-md-4 col-sm-6 col-12 custom8"
                          >
                            <fieldset>
                              <legend
                                className="col-form-legend"
                                style={{
                                  fontSize: ".8rem",
                                  paddingBottom: "3px",
                                  fontWeight: "700",
                                }}
                              >
                                {translate("Mode")}
                              </legend>
                              <div
                                className="text-left box"
                                style={{ paddingBottom: ".1rem" }}
                              >
                                <Input
                                  type="radio"
                                  className="form-check-input"
                                  name="statusRadio2"
                                  id="StatusRadio2A"
                                  ref={(input) => {
                                    window.TestingDoms["docsViewModeRadio2A"] =
                                      input;
                                  }}
                                  value=""
                                  defaultChecked={searchParams.Run === ""}
                                  onChange={(e) =>
                                    this.props.handleParamChange("Run", "")
                                  }
                                />
                                <Label
                                  htmlFor="StatusRadio2A"
                                  className="form-check-label"
                                  style={{ lineHeight: "1.5" }}
                                >
                                  {translate("All")}
                                </Label>
                              </div>
                              <div
                                className="text-left box"
                                style={{
                                  paddingBottom: ".1rem",
                                  lineHeight: "1.5",
                                }}
                              >
                                <Input
                                  type="radio"
                                  className="form-check-input"
                                  name="statusRadio2"
                                  id="StatusRadio2TMode"
                                  ref={(input) => {
                                    window.TestingDoms["docsViewModeRadio2T"] =
                                      input;
                                  }}
                                  value="t"
                                  defaultChecked={searchParams.Run === "t"}
                                  onChange={(e) =>
                                    this.props.handleParamChange("Run", "t")
                                  }
                                />
                                <Label
                                  htmlFor="StatusRadio2TMode"
                                  className="form-check-label"
                                >
                                  {translate("Test")}
                                </Label>
                              </div>
                              <div
                                className="text-left box"
                                style={{
                                  paddingBottom: ".1rem",
                                  lineHeight: "1.5",
                                }}
                              >
                                <Input
                                  type="radio"
                                  className="form-check-input"
                                  name="statusRadio2"
                                  id="StatusRadio2TPMode"
                                  value="p"
                                  ref={(input) => {
                                    window.TestingDoms["docsViewModeRadio2TP"] =
                                      input;
                                  }}
                                  defaultChecked={searchParams.Run === "p"}
                                  onChange={(e) =>
                                    this.props.handleParamChange("Run", "p")
                                  }
                                />
                                <Label
                                  htmlFor="StatusRadio2TPMode"
                                  className="form-check-label"
                                >
                                  {translate("Production")}
                                </Label>
                              </div>
                            </fieldset>
                          </div>
                          <div
                            hidden={isSender}
                            className="form-group col-xl col-lg-2 col-md-4 col-sm-6 col-12 external_hide custom8"
                          >
                            <fieldset>
                              <div
                                className="col-lg-12 col-md-12 col-sm-12 form-group w_chosen"
                                style={{ marginBottom: ".4rem" }}
                              >
                                <Label
                                  htmlFor="filter_internal_number"
                                  style={{
                                    lineHeight: "4px",
                                    fontWeight: "700",
                                    paddingTop: "0.375rem",
                                  }}
                                >
                                  {translate("Internal ID")}
                                </Label>
                                <Input
                                  type="text"
                                  name="filter_internal_number"
                                  ref={(input) => {
                                    window.TestingDoms[
                                      "docsViewFilterInternalNumber"
                                    ] = input;
                                  }}
                                  defaultValue={searchParams.DocId}
                                  onChange={(e) =>
                                    this.props.handleParamChange(
                                      "DocId",
                                      e.target.value
                                    )
                                  }
                                  id="filter_internal_number"
                                  placeholder={translate(
                                    "platformSpecificEBIDPlaceholder"
                                  )}
                                  className="form-control"
                                  style={{
                                    lineHeight: "6px",
                                    border: "1px solid #808080",
                                  }}
                                />
                              </div>
                              <div
                                className="col-lg-12 col-md-12 col-sm-12 form-group w_chosen external_hide"
                                style={{ marginBottom: ".4rem" }}
                              >
                                <Label
                                  style={{
                                    lineHeight: "4px",
                                    fontWeight: "700",
                                  }}
                                >
                                  {translate("Channel")}
                                </Label>
                                <Select
                                  name="channelComboBox"
                                  disabled={!!this.props.docListFromFileLoaded}
                                  className="channelComboBox chosen_static_search w_action_select allow-custom-input form-control min-width-to-100"
                                  ref={(input) => {
                                    window.TestingDoms["docsViewChannelName"] =
                                      input;
                                  }}
                                  value={searchParams.ChannelName}
                                  placeholder={`${translate(
                                    "SelectChannel"
                                  )}...`}
                                  onChange={this.onSelectedChannelChange.bind(
                                    this
                                  )}
                                  options={channelOptions}
                                />
                              </div>
                            </fieldset>
                          </div>
                          <div
                            hidden={isSender}
                            className="form-group col-xl col-lg-2 col-md-4 col-sm-6 col-12 custom8"
                          >
                            <fieldset>
                              <div
                                className="col-lg-12 col-md-12 col-sm-12 form-group"
                                style={{ marginBottom: ".4rem" }}
                              >
                                <Label
                                  htmlFor="filter_sender"
                                  style={{
                                    lineHeight: "4px",
                                    fontWeight: "700",
                                    paddingTop: "0.375rem",
                                  }}
                                >
                                  {translate("Sender")}
                                </Label>
                                <strong>{" ["}</strong>
                                <button
                                  type="button"
                                  className={`sender-toggle-btn ${
                                    searchParams.BySenderId ? "active-btn" : ""
                                  }`}
                                  onClick={() =>
                                    this.toggleSenderIdSetting(true)
                                  }
                                >
                                  {translate("Name")}
                                </button>
                                <button
                                  type="button"
                                  style={{ margin: 0 }}
                                  className={`sender-toggle-btn ${
                                    searchParams.BySenderId ? "" : "active-btn"
                                  }`}
                                  onClick={() =>
                                    this.toggleSenderIdSetting(false)
                                  }
                                >
                                  ID
                                </button>
                                <strong>{" ]"}</strong>
                                <Input
                                  type="text"
                                  name="filter_sender"
                                  defaultValue={searchParams.Sender}
                                  ref={(input) => {
                                    window.TestingDoms["docsViewFilterSender"] =
                                      input;
                                  }}
                                  onChange={(e) => {
                                    this.props.handleParamChange(
                                      "Sender",
                                      e.target.value
                                    );
                                  }}
                                  placeholder={translate("Name")}
                                  className="form-control"
                                  style={{
                                    lineHeight: "6px",
                                    border: "1px solid #808080",
                                  }}
                                />
                              </div>
                              <div
                                className="col-lg-12 col-md-12 col-sm-12 form-group"
                                style={{ marginBottom: ".4rem" }}
                              >
                                <Label
                                  htmlFor="filter_receiver"
                                  style={{
                                    lineHeight: "4px",
                                    fontWeight: "700",
                                  }}
                                >
                                  {translate("Receiver")}
                                </Label>
                                <strong>{" ["}</strong>
                                <button
                                  type="button"
                                  className={`sender-toggle-btn ${
                                    searchParams.ByReceiverId
                                      ? "active-btn"
                                      : ""
                                  }`}
                                  onClick={() =>
                                    this.toggleReceiverIdSetting(true)
                                  }
                                >
                                  {translate("Name")}
                                </button>
                                <button
                                  type="button"
                                  style={{ margin: 0 }}
                                  className={`sender-toggle-btn ${
                                    searchParams.ByReceiverId
                                      ? ""
                                      : "active-btn"
                                  }`}
                                  onClick={() =>
                                    this.toggleReceiverIdSetting(false)
                                  }
                                >
                                  ID
                                </button>
                                <strong>{" ]"}</strong>
                                <Input
                                  type="text"
                                  name="filter_receiver"
                                  id="filter_receiver"
                                  defaultValue={searchParams.Receiver}
                                  ref={(input) => {
                                    window.TestingDoms[
                                      "docsViewFilterReceiver"
                                    ] = input;
                                  }}
                                  onChange={(e) => {
                                    this.props.handleParamChange(
                                      "Receiver",
                                      e.target.value
                                    );
                                  }}
                                  placeholder={translate("Name")}
                                  className="form-control"
                                  style={{
                                    lineHeight: "6px",
                                    border: "1px solid #808080",
                                  }}
                                />
                              </div>
                            </fieldset>
                          </div>
                          <div className="form-group col-xl col-lg-2 col-md-3 col-sm-6 col-12 custom8">
                            <fieldset
                              style={{
                                height: "100%",
                              }}
                            >
                              <div
                                className="form-group col-lg-12 col-md-12 col-sm-12"
                                style={{
                                  padding: 0,
                                }}
                              >
                                <Label
                                  htmlFor="datePeriod"
                                  className="col-form-label"
                                  style={{
                                    lineHeight: "4px",
                                    fontWeight: "700",
                                    paddingTop: "0.375rem",
                                  }}
                                >
                                  {translate("TimePeriod")}
                                </Label>
                                <div
                                  className="text-left"
                                  style={{
                                    display: "flex",
                                    flexDirection: "column",
                                    height: "100%",
                                  }}
                                >
                                  <div className="datetime-filter">
                                    <Label
                                      htmlFor="startDate"
                                      style={{
                                        padding: "0.6em",
                                        fontWeight: "600",
                                        margin: 0,
                                        width: "55px",
                                        textAlign: "left",
                                      }}
                                    >
                                      {translate("From")}
                                    </Label>
                                    <Datetime
                                      value={searchParams.Start}
                                      utc={true}
                                      locale={getMomentLocaleByLang(
                                        userLanguage
                                      )}
                                      dateFormat="DD-MM-YYYY"
                                      timeFormat="HH:mm"
                                      inputProps={{
                                        placeholder: "dd-MM-yyyy HH:mm",
                                        className:
                                          "--date-picker-custom form-control",
                                        disabled:
                                          !!this.props.docListFromFileLoaded,
                                      }}
                                      onChange={(Start) => {
                                        const _date = moment(Start).toDate();
                                        this.props.dispatch(
                                          actions.change(
                                            "docSearch.Start",
                                            _date instanceof Date ? _date : ""
                                          )
                                        );
                                      }}
                                    />
                                  </div>
                                  <div className="datetime-filter">
                                    <Label
                                      htmlFor="endDate"
                                      style={{
                                        padding: "0.6em",
                                        fontWeight: "600",
                                        margin: 0,
                                        width: "55px",
                                        textAlign: "left",
                                      }}
                                    >
                                      {translate("Till")}
                                    </Label>
                                    <Datetime
                                      value={searchParams.End}
                                      utc={true}
                                      locale={getMomentLocaleByLang(
                                        userLanguage
                                      )}
                                      dateFormat="DD-MM-YYYY"
                                      timeFormat="HH:mm"
                                      inputProps={{
                                        placeholder: "dd-MM-yyyy HH:mm",
                                        className:
                                          "--date-picker-custom datetime-filter form-control",
                                        disabled:
                                          !!this.props.docListFromFileLoaded,
                                      }}
                                      onChange={(End) => {
                                        const _date = moment(End).toDate();
                                        this.props.dispatch(
                                          actions.change(
                                            "docSearch.End",
                                            _date instanceof Date ? _date : ""
                                          )
                                        );
                                      }}
                                    />
                                  </div>
                                </div>
                                <div
                                  className="container time-period-btns"
                                  style={{
                                    width: "fit-content",
                                    marginTop: "1em",
                                  }}
                                >
                                  <Row>
                                    <Col style={{ padding: 0 }}>
                                      <button
                                        type="button"
                                        className="btn btn-primary btn-sm"
                                        onClick={this.onLastDayBtnClick}
                                      >
                                        {translate("LastDay")}
                                      </button>
                                    </Col>
                                    <Col style={{ padding: 0 }}>
                                      <button
                                        type="button"
                                        className="btn btn-primary btn-sm"
                                        onClick={this.onLast7DayBtnClick}
                                      >
                                        {translate("Last 7 days")}
                                      </button>
                                    </Col>
                                    <Col style={{ padding: 0 }}>
                                      <button
                                        type="button"
                                        className="btn btn-primary btn-sm"
                                        onClick={this.onLastMonthBtnClick}
                                      >
                                        {translate("Last Month")}
                                      </button>
                                    </Col>
                                  </Row>
                                </div>
                              </div>
                            </fieldset>
                          </div>
                        </div>
                      </div>
                    ) : (
                      <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                        <div
                          className="row justify-content-center top_more_style"
                          style={{
                            marginTop: ".5rem",
                            marginBottom: ".5rem",
                          }}
                        >
                          <div
                            className="col-xl col-lg-2 col-md-3 col-sm-6 col-12"
                            style={{ minWidth: "45%", marginTop: "-5px" }}
                          >
                            <Nav tabs>
                              <NavItem>
                                <NavLink
                                  className={classnames({
                                    active:
                                      this.props.docsViewActiveTabs === "1",
                                  })}
                                  onClick={() => {
                                    this.toggleDocsViewActiveTab("1");
                                  }}
                                  style={{ padding: "0rem 1rem" }}
                                >
                                  {translate("Delivery parties")}
                                </NavLink>
                              </NavItem>
                              <NavItem>
                                <NavLink
                                  className={classnames({
                                    active:
                                      this.props.docsViewActiveTabs === "2",
                                  })}
                                  onClick={() => {
                                    this.toggleDocsViewActiveTab("2");
                                  }}
                                  style={{ padding: "0rem 1rem" }}
                                >
                                  {translate("Statuses")}
                                </NavLink>
                              </NavItem>
                            </Nav>
                            <TabContent
                              activeTab={this.props.docsViewActiveTabs}
                            >
                              <TabPane tabId="1">
                                <div className="col-lg-12 col-md-12 col-sm-12 col-sm-12 col-12">
                                  <div
                                    className="row"
                                    style={{
                                      marginTop: "0",
                                    }}
                                  >
                                    <div className="form-group col-xl col-lg-4 col-md-4 col-sm-6 col-12 custom8">
                                      <fieldset
                                        style={{ paddingBottom: "0.5rem" }}
                                      >
                                        <Label
                                          style={{
                                            marginBottom: "0.2rem",
                                            fontSize: "0.8rem",
                                            fontWeight: "700",
                                          }}
                                        >
                                          {translate("Platform")}
                                        </Label>
                                        <div style={{ textAlign: "left" }}>
                                          <div
                                            className="col-lg-12 col-md-12 col-sm-12 form-group"
                                            style={{
                                              padding: 0,
                                              marginBottom: ".4rem",
                                            }}
                                          >
                                            <Select
                                              name="platformComboBox"
                                              className="channelComboBox chosen_static_search w_action_select allow-custom-input form-control min-width-to-100"
                                              value={
                                                searchParams.Platform || "All"
                                              }
                                              placeholder={`${translate(
                                                "Platform"
                                              )}...`}
                                              onChange={this.onSelectedPlatformChange.bind(
                                                this
                                              )}
                                              options={platformOptions}
                                              clearable={false}
                                            />
                                          </div>
                                        </div>
                                      </fieldset>
                                    </div>
                                    <div className="form-group col-xl col-lg-4 col-md-4 col-sm-6 col-12 external_hide custom8">
                                      <fieldset>
                                        <div
                                          className="col-lg-12 col-md-12 col-sm-12 form-group"
                                          style={{
                                            padding: 0,
                                            marginBottom: ".4rem",
                                          }}
                                        >
                                          <Label
                                            htmlFor="filter_legacy_id"
                                            style={{
                                              lineHeight: "4px",
                                              fontWeight: "700",
                                              paddingTop: "0.375rem",
                                            }}
                                          >
                                            {translate("Customer Legacy ID")}
                                          </Label>
                                          <Input
                                            type="text"
                                            disabled={
                                              !!this.props.docListFromFileLoaded
                                            }
                                            name="filter_legacy_id"
                                            defaultValue={
                                              searchParams.CustomerLegacyId
                                            }
                                            onChange={this.onCustomerLegacyIdChange.bind(
                                              this
                                            )}
                                            placeholder="ID"
                                            className="form-control"
                                            style={{
                                              lineHeight: "6px",
                                              border: "1px solid #808080",
                                            }}
                                          />
                                        </div>
                                        <div
                                          className="col-lg-12 col-md-12 col-sm-12 form-group"
                                          style={{
                                            padding: 0,
                                            marginBottom: ".4rem",
                                          }}
                                        >
                                          <Label
                                            htmlFor="filter_batch_id"
                                            style={{
                                              lineHeight: "4px",
                                              fontWeight: "700",
                                            }}
                                          >
                                            {translate("Batch ID")}
                                          </Label>
                                          <Input
                                            type="text"
                                            name="filter_batch_id"
                                            id="filter_batch_id"
                                            defaultValue={searchParams.batch}
                                            ref={(input) => {
                                              window.TestingDoms[
                                                "docsViewFilterBatchId"
                                              ] = input;
                                            }}
                                            onChange={(e) =>
                                              this.props.handleParamChange(
                                                "batch",
                                                e.target.value
                                              )
                                            }
                                            placeholder="ID"
                                            className="form-control"
                                            style={{
                                              lineHeight: "6px",
                                              border: "1px solid #808080",
                                            }}
                                          />
                                        </div>
                                      </fieldset>
                                    </div>
                                    <div
                                      hidden={isSender}
                                      className="form-group col-xl col-lg-4 col-md-4 col-sm-6 col-12 custom8"
                                    >
                                      <fieldset>
                                        <div
                                          className="col-lg-12 col-md-12 col-sm-12 form-group"
                                          style={{
                                            padding: 0,
                                            marginBottom: ".4rem",
                                          }}
                                        >
                                          <Label
                                            htmlFor="filter_sender"
                                            style={{
                                              lineHeight: "4px",
                                              fontWeight: "700",
                                              paddingTop: "0.375rem",
                                            }}
                                          >
                                            {translate("Sender")}
                                          </Label>
                                          <strong>{" ["}</strong>
                                          <button
                                            type="button"
                                            className={`sender-toggle-btn ${
                                              searchParams.BySenderId
                                                ? "active-btn"
                                                : ""
                                            }`}
                                            onClick={() =>
                                              this.toggleSenderIdSetting(true)
                                            }
                                          >
                                            {translate("Name")}
                                          </button>
                                          <button
                                            type="button"
                                            style={{ margin: 0 }}
                                            className={`sender-toggle-btn ${
                                              searchParams.BySenderId
                                                ? ""
                                                : "active-btn"
                                            }`}
                                            onClick={() =>
                                              this.toggleSenderIdSetting(false)
                                            }
                                          >
                                            ID
                                          </button>
                                          <strong>{" ]"}</strong>
                                          <Input
                                            type="text"
                                            name="filter_sender"
                                            defaultValue={searchParams.Sender}
                                            ref={(input) => {
                                              window.TestingDoms[
                                                "docsViewFilterSender"
                                              ] = input;
                                            }}
                                            onChange={(e) => {
                                              this.props.handleParamChange(
                                                "Sender",
                                                e.target.value
                                              );
                                            }}
                                            placeholder={translate("Name")}
                                            className="form-control"
                                            style={{
                                              lineHeight: "6px",
                                              border: "1px solid #808080",
                                            }}
                                          />
                                        </div>
                                        <div
                                          className="col-lg-12 col-md-12 col-sm-12 form-group"
                                          style={{
                                            padding: 0,
                                            marginBottom: ".4rem",
                                          }}
                                        >
                                          <Label
                                            htmlFor="filter_receiver"
                                            style={{
                                              lineHeight: "4px",
                                              fontWeight: "700",
                                            }}
                                          >
                                            {translate("Receiver")}
                                          </Label>
                                          <strong>{" ["}</strong>
                                          <button
                                            type="button"
                                            className={`sender-toggle-btn ${
                                              searchParams.ByReceiverId
                                                ? "active-btn"
                                                : ""
                                            }`}
                                            onClick={() =>
                                              this.toggleReceiverIdSetting(true)
                                            }
                                          >
                                            {translate("Name")}
                                          </button>
                                          <button
                                            type="button"
                                            style={{ margin: 0 }}
                                            className={`sender-toggle-btn ${
                                              searchParams.ByReceiverId
                                                ? ""
                                                : "active-btn"
                                            }`}
                                            onClick={() =>
                                              this.toggleReceiverIdSetting(
                                                false
                                              )
                                            }
                                          >
                                            ID
                                          </button>
                                          <strong>{" ]"}</strong>
                                          <Input
                                            type="text"
                                            name="filter_receiver"
                                            id="filter_receiver"
                                            defaultValue={searchParams.Receiver}
                                            ref={(input) => {
                                              window.TestingDoms[
                                                "docsViewFilterReceiver"
                                              ] = input;
                                            }}
                                            onChange={(e) => {
                                              this.props.handleParamChange(
                                                "Receiver",
                                                e.target.value
                                              );
                                            }}
                                            placeholder={translate("Name")}
                                            className="form-control"
                                            style={{
                                              lineHeight: "6px",
                                              border: "1px solid #808080",
                                            }}
                                          />
                                        </div>
                                      </fieldset>
                                    </div>
                                  </div>
                                </div>
                              </TabPane>
                              <TabPane tabId="2">
                                <div className="col-lg-12 col-md-12 col-sm-12 col-sm-12 col-12">
                                  <div
                                    className="row"
                                    style={{
                                      marginTop: "0",
                                    }}
                                  >
                                    <div className="form-group col-xl col-lg-4 col-md-4 col-sm-6 col-12 custom8">
                                      <fieldset
                                        style={{ paddingBottom: "0.5rem" }}
                                      >
                                        <div
                                          className="col-lg-12 col-md-12 col-sm-12 form-group"
                                          style={{
                                            padding: 0,
                                            marginBottom: ".4rem",
                                          }}
                                        >
                                          <Label
                                            style={{
                                              marginBottom: "0.2rem",
                                              fontSize: "0.8rem",
                                              fontWeight: "700",
                                            }}
                                          >
                                            {translate("Delivery status")}
                                          </Label>
                                          <div style={{ textAlign: "left" }}>
                                            <div
                                              className="col-lg-12 col-md-12 col-sm-12 form-group"
                                              style={{
                                                marginBottom: ".4rem",
                                              }}
                                            >
                                              <Select
                                                name="statusComboBox"
                                                className="channelComboBox chosen_static_search w_action_select allow-custom-input form-control min-width-to-100"
                                                value={
                                                  searchParams.DocStatus ||
                                                  "All"
                                                }
                                                placeholder={`${translate(
                                                  "Status"
                                                )}...`}
                                                onChange={(selected) => {
                                                  if (selected) {
                                                    this.props.handleParamChange(
                                                      "DocStatus",
                                                      selected.value
                                                    );
                                                  } else {
                                                    this.props.handleParamChange(
                                                      "DocStatus",
                                                      "All"
                                                    );
                                                  }
                                                }}
                                                options={docStatusOptions}
                                                clearable={false}
                                              />
                                              <div
                                                style={{
                                                  margin: "0.8em 2em",
                                                }}
                                              >
                                                <Input
                                                  className="form-check-input"
                                                  type="checkbox"
                                                  defaultChecked={
                                                    searchParams.hasbbs
                                                  }
                                                  id="hasbbsDocuments"
                                                  onChange={(e) =>
                                                    this.props.handleParamChange(
                                                      "hasbbs",
                                                      e.target.checked
                                                    )
                                                  }
                                                />
                                                <Label
                                                  htmlFor="hasbbsDocuments"
                                                  className="form-check-label"
                                                >
                                                  {translate(
                                                    "ShowOnlyDocumentsBouncebacks"
                                                  )}
                                                </Label>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </fieldset>
                                    </div>
                                    <div className="form-group col-xl col-lg-4 col-md-4 col-sm-6 col-12 external_hide custom8">
                                      <fieldset
                                        style={{
                                          padding: 0,
                                        }}
                                      >
                                        <div
                                          className="col-lg-12 col-md-12 col-sm-12 form-group"
                                          style={{
                                            padding: 0,
                                            marginBottom: ".4rem",
                                          }}
                                        >
                                          <div style={{ textAlign: "left" }}>
                                            <div
                                              className="col-lg-12 col-md-12 col-sm-12 form-group"
                                              style={{
                                                padding: 0,
                                                marginBottom: ".2em",
                                              }}
                                            >
                                              <Label
                                                htmlFor="filter_sender"
                                                style={{
                                                  lineHeight: "2px",
                                                  fontWeight: "700",
                                                }}
                                              >
                                                {translate(
                                                  "Has receiver statuses"
                                                )}
                                              </Label>
                                              <strong>{" ["}</strong>
                                              <button
                                                type="button"
                                                className={`sender-toggle-btn ${
                                                  searchParams.TctIn
                                                    ? ""
                                                    : "active-btn"
                                                }`}
                                                onClick={() =>
                                                  this.toggleWithAndStatuses(
                                                    false
                                                  )
                                                }
                                              >
                                                AND
                                              </button>
                                              <button
                                                type="button"
                                                className={`sender-toggle-btn ${
                                                  searchParams.TctIn
                                                    ? "active-btn"
                                                    : ""
                                                }`}
                                                onClick={() =>
                                                  this.toggleWithAndStatuses(
                                                    true
                                                  )
                                                }
                                                style={{ margin: 0 }}
                                              >
                                                OR
                                              </button>
                                              <strong>{" ]"}</strong>
                                              <div
                                                style={{
                                                  textAlign: "left",
                                                }}
                                              >
                                                <Select
                                                  value={searchParams.Tags}
                                                  multi={true}
                                                  placeholder={`${translate(
                                                    "Tags"
                                                  )}...`}
                                                  name="Tags"
                                                  options={tagsOptions}
                                                  className="channelComboBox multiselect-status chosen_static_search w_action_select allow-custom-input form-control min-width-to-100"
                                                  onChange={(value) => {
                                                    this.props.handleParamChange(
                                                      "Tags",
                                                      value
                                                    );
                                                  }}
                                                />
                                              </div>
                                            </div>
                                            <div
                                              className="col-lg-12 col-md-12 col-sm-12 form-group"
                                              style={{
                                                padding: 0,
                                                marginBottom: ".2em",
                                              }}
                                            >
                                              <Label
                                                htmlFor="filter_batch_id"
                                                style={{
                                                  lineHeight: "2px",
                                                  fontWeight: "700",
                                                }}
                                              >
                                                {translate(
                                                  "Doesn't have receiver statuses"
                                                )}
                                              </Label>
                                              <div
                                                style={{
                                                  textAlign: "left",
                                                }}
                                              >
                                                <Select
                                                  value={searchParams.NTags}
                                                  multi={true}
                                                  placeholder={`${translate(
                                                    "Tags"
                                                  )}...`}
                                                  name="NTags"
                                                  options={tagsOptions}
                                                  className="channelComboBox multiselect-status chosen_static_search w_action_select allow-custom-input form-control min-width-to-100"
                                                  onChange={(value) => {
                                                    this.props.handleParamChange(
                                                      "NTags",
                                                      value
                                                    );
                                                  }}
                                                />
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </fieldset>
                                    </div>
                                  </div>
                                </div>
                              </TabPane>
                            </TabContent>
                          </div>
                          <div
                            hidden={isSender}
                            className="form-group col-xl col-lg-2 col-md-4 col-sm-6 col-12 custom8"
                          >
                            <fieldset>
                              <legend
                                className="col-form-legend"
                                style={{
                                  fontSize: ".8rem",
                                  paddingBottom: "3px",
                                  fontWeight: "700",
                                }}
                              >
                                {translate("Mode")}
                              </legend>
                              <div
                                className="text-left box"
                                style={{ paddingBottom: ".1rem" }}
                              >
                                <Input
                                  type="radio"
                                  className="form-check-input"
                                  name="statusRadio2"
                                  id="StatusRadio2A"
                                  ref={(input) => {
                                    window.TestingDoms["docsViewModeRadio2A"] =
                                      input;
                                  }}
                                  value=""
                                  defaultChecked={searchParams.Run === ""}
                                  onChange={(e) =>
                                    this.props.handleParamChange("Run", "")
                                  }
                                />
                                <Label
                                  htmlFor="StatusRadio2A"
                                  className="form-check-label"
                                  style={{ lineHeight: "1.5" }}
                                >
                                  {translate("All")}
                                </Label>
                              </div>
                              <div
                                className="text-left box"
                                style={{
                                  paddingBottom: ".1rem",
                                  lineHeight: "1.5",
                                }}
                              >
                                <Input
                                  type="radio"
                                  className="form-check-input"
                                  name="statusRadio2"
                                  id="StatusRadio2TMode"
                                  ref={(input) => {
                                    window.TestingDoms["docsViewModeRadio2T"] =
                                      input;
                                  }}
                                  value="t"
                                  defaultChecked={searchParams.Run === "t"}
                                  onChange={(e) =>
                                    this.props.handleParamChange("Run", "t")
                                  }
                                />
                                <Label
                                  htmlFor="StatusRadio2TMode"
                                  className="form-check-label"
                                >
                                  {translate("Test")}
                                </Label>
                              </div>
                              <div
                                className="text-left box"
                                style={{
                                  paddingBottom: ".1rem",
                                  lineHeight: "1.5",
                                }}
                              >
                                <Input
                                  type="radio"
                                  className="form-check-input"
                                  name="statusRadio2"
                                  id="StatusRadio2TPMode"
                                  value="p"
                                  ref={(input) => {
                                    window.TestingDoms["docsViewModeRadio2TP"] =
                                      input;
                                  }}
                                  defaultChecked={searchParams.Run === "p"}
                                  onChange={(e) =>
                                    this.props.handleParamChange("Run", "p")
                                  }
                                />
                                <Label
                                  htmlFor="StatusRadio2TPMode"
                                  className="form-check-label"
                                >
                                  {translate("Production")}
                                </Label>
                              </div>
                            </fieldset>
                          </div>
                          <div
                            hidden={isSender}
                            className="form-group col-xl col-lg-2 col-md-4 col-sm-6 col-12 external_hide custom8"
                          >
                            <fieldset>
                              <div
                                className="col-lg-12 col-md-12 col-sm-12 form-group w_chosen"
                                style={{ marginBottom: ".4rem" }}
                              >
                                <Label
                                  htmlFor="filter_internal_number"
                                  style={{
                                    lineHeight: "4px",
                                    fontWeight: "700",
                                    paddingTop: "0.375rem",
                                  }}
                                >
                                  {translate("Internal ID")}
                                </Label>
                                <Input
                                  type="text"
                                  name="filter_internal_number"
                                  ref={(input) => {
                                    window.TestingDoms[
                                      "docsViewFilterInternalNumber"
                                    ] = input;
                                  }}
                                  defaultValue={searchParams.DocId}
                                  onChange={(e) =>
                                    this.props.handleParamChange(
                                      "DocId",
                                      e.target.value
                                    )
                                  }
                                  id="filter_internal_number"
                                  placeholder={translate(
                                    "platformSpecificEBIDPlaceholder"
                                  )}
                                  className="form-control"
                                  style={{
                                    lineHeight: "6px",
                                    border: "1px solid #808080",
                                  }}
                                />
                              </div>
                              <div
                                className="col-lg-12 col-md-12 col-sm-12 form-group w_chosen external_hide"
                                style={{ marginBottom: ".4rem" }}
                              >
                                <Label
                                  style={{
                                    lineHeight: "4px",
                                    fontWeight: "700",
                                  }}
                                >
                                  {translate("Channel")}
                                </Label>
                                <Select
                                  name="channelComboBox"
                                  disabled={!!this.props.docListFromFileLoaded}
                                  className="channelComboBox chosen_static_search w_action_select allow-custom-input form-control min-width-to-100"
                                  ref={(input) => {
                                    window.TestingDoms["docsViewChannelName"] =
                                      input;
                                  }}
                                  value={searchParams.ChannelName}
                                  placeholder={`${translate(
                                    "SelectChannel"
                                  )}...`}
                                  onChange={this.onSelectedChannelChange.bind(
                                    this
                                  )}
                                  options={channelOptions}
                                />
                              </div>
                            </fieldset>
                          </div>
                          <div className="form-group col-xl col-lg-2 col-md-3 col-sm-6 col-12 custom8">
                            <fieldset
                              style={{
                                height: "100%",
                              }}
                            >
                              <div
                                className="form-group col-lg-12 col-md-12 col-sm-12"
                                style={{
                                  padding: 0,
                                }}
                              >
                                <Label
                                  htmlFor="datePeriod"
                                  className="col-form-label"
                                  style={{
                                    lineHeight: "4px",
                                    fontWeight: "700",
                                    paddingTop: "0.375rem",
                                  }}
                                >
                                  {translate("TimePeriod")}
                                </Label>
                                <div
                                  className="text-left"
                                  style={{
                                    display: "flex",
                                    flexDirection: "column",
                                    height: "100%",
                                  }}
                                >
                                  <div className="datetime-filter">
                                    <Label
                                      htmlFor="startDate"
                                      style={{
                                        padding: "0.6em",
                                        fontWeight: "600",
                                        margin: 0,
                                        width: "55px",
                                        textAlign: "left",
                                      }}
                                    >
                                      {translate("From")}
                                    </Label>
                                    <Datetime
                                      value={searchParams.Start}
                                      utc={true}
                                      locale={getMomentLocaleByLang(
                                        userLanguage
                                      )}
                                      dateFormat="DD-MM-YYYY"
                                      timeFormat="HH:mm"
                                      inputProps={{
                                        placeholder: "dd-MM-yyyy HH:mm",
                                        className:
                                          "--date-picker-custom form-control",
                                        disabled:
                                          !!this.props.docListFromFileLoaded,
                                      }}
                                      onChange={(Start) => {
                                        const _date = moment(Start).toDate();
                                        this.props.dispatch(
                                          actions.change(
                                            "docSearch.Start",
                                            _date instanceof Date ? _date : ""
                                          )
                                        );
                                      }}
                                    />
                                  </div>
                                  <div className="datetime-filter">
                                    <Label
                                      htmlFor="endDate"
                                      style={{
                                        padding: "0.6em",
                                        fontWeight: "600",
                                        margin: 0,
                                        width: "55px",
                                        textAlign: "left",
                                      }}
                                    >
                                      {translate("Till")}
                                    </Label>
                                    <Datetime
                                      value={searchParams.End}
                                      utc={true}
                                      locale={getMomentLocaleByLang(
                                        userLanguage
                                      )}
                                      dateFormat="DD-MM-YYYY"
                                      timeFormat="HH:mm"
                                      inputProps={{
                                        placeholder: "dd-MM-yyyy HH:mm",
                                        className:
                                          "--date-picker-custom datetime-filter form-control",
                                        disabled:
                                          !!this.props.docListFromFileLoaded,
                                      }}
                                      onChange={(End) => {
                                        const _date = moment(End).toDate();
                                        this.props.dispatch(
                                          actions.change(
                                            "docSearch.End",
                                            _date instanceof Date ? _date : ""
                                          )
                                        );
                                      }}
                                    />
                                  </div>
                                </div>
                                <div
                                  className="container time-period-btns"
                                  style={{
                                    width: "fit-content",
                                    marginTop: "1em",
                                  }}
                                >
                                  <Row>
                                    <Col style={{ padding: 0 }}>
                                      <button
                                        type="button"
                                        className="btn btn-primary btn-sm"
                                        onClick={this.onLastDayBtnClick}
                                      >
                                        {translate("LastDay")}
                                      </button>
                                    </Col>
                                    <Col style={{ padding: 0 }}>
                                      <button
                                        type="button"
                                        className="btn btn-primary btn-sm"
                                        onClick={this.onLast7DayBtnClick}
                                      >
                                        {translate("Last 7 days")}
                                      </button>
                                    </Col>
                                    <Col style={{ padding: 0 }}>
                                      <button
                                        type="button"
                                        className="btn btn-primary btn-sm"
                                        onClick={this.onLastMonthBtnClick}
                                      >
                                        {translate("Last Month")}
                                      </button>
                                    </Col>
                                  </Row>
                                </div>
                              </div>
                            </fieldset>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              )}

              {(view === "execReportsView" || view === "configReportsView") && (
                <div className="col-lg-12 col-md-12 col-sm-12 col-12">
                  <div
                    className="row"
                    style={{ borderBottom: "solid 1px #CCCCCC" }}
                  >
                    <div className="col-lg-12 col-md-12 col-sm-12 col-sm-12 col-12">
                      <div
                        className="row justify-content-center top_more_style"
                        style={{ marginTop: ".5rem", marginBottom: ".5rem" }}
                      >
                        {view === "execReportsView" &&
                          !this.props.isExternalUser && (
                            <div className="form-group col-xl-2 col-lg-2 col-md-4 col-sm-6 col-12 custom8">
                              <fieldset className="">
                                <legend
                                  className="col-form-legend"
                                  style={{
                                    fontSize: ".8rem",
                                    paddingBottom: "3px",
                                    fontWeight: "700",
                                  }}
                                >
                                  {translate("Status")}
                                </legend>
                                <div
                                  className="text-left box"
                                  style={{ paddingBottom: ".1rem" }}
                                >
                                  <Input
                                    type="radio"
                                    className="form-check-input"
                                    name="reportStateRadio"
                                    id="ReportStateAll"
                                    value=""
                                    ref={(input) => {
                                      window.TestingDoms[
                                        "execReportsViewStatusRadio2A"
                                      ] = input;
                                    }}
                                    defaultChecked={
                                      searchParams.ReportState === ""
                                    }
                                    onChange={(e) =>
                                      this.props.dispatch(
                                        actions.change(
                                          "execReportSearch.ReportState",
                                          e.target.value
                                        )
                                      )
                                    }
                                  />
                                  <Label
                                    htmlFor="ReportStateAll"
                                    className="form-check-label"
                                  >
                                    {translate("All")}
                                  </Label>
                                </div>
                                <div
                                  className="text-left box"
                                  style={{ paddingBottom: ".1rem" }}
                                >
                                  <Input
                                    type="radio"
                                    className="form-check-input"
                                    name="reportStateRadio"
                                    id="ReportStateFinished"
                                    value="finished"
                                    ref={(input) => {
                                      window.TestingDoms[
                                        "execReportsViewStatusRadio2D"
                                      ] = input;
                                    }}
                                    defaultChecked={
                                      searchParams.ReportState === "finished"
                                    }
                                    onChange={(e) =>
                                      this.props.dispatch(
                                        actions.change(
                                          "execReportSearch.ReportState",
                                          e.target.value
                                        )
                                      )
                                    }
                                  />
                                  <Label
                                    htmlFor="ReportStateFinished"
                                    className="form-check-label"
                                  >
                                    {translate("Succeeded")}
                                  </Label>
                                </div>
                                <div
                                  className="text-left box"
                                  style={{ paddingBottom: ".1rem" }}
                                >
                                  <Input
                                    type="radio"
                                    className="form-check-input"
                                    name="reportStateRadio"
                                    id="ReportStateFailed"
                                    value="failed"
                                    ref={(input) => {
                                      window.TestingDoms[
                                        "execReportsViewStatusRadio2P"
                                      ] = input;
                                    }}
                                    defaultChecked={
                                      searchParams.ReportState === "failed"
                                    }
                                    onChange={(e) =>
                                      this.props.dispatch(
                                        actions.change(
                                          "execReportSearch.ReportState",
                                          e.target.value
                                        )
                                      )
                                    }
                                  />
                                  <Label
                                    htmlFor="ReportStateFailed"
                                    className="form-check-label"
                                  >
                                    {translate("Failed")}
                                  </Label>
                                </div>
                                <div
                                  className="text-left box"
                                  style={{ paddingBottom: ".1rem" }}
                                >
                                  <Input
                                    type="radio"
                                    className="form-check-input"
                                    name="reportStateRadio"
                                    id="ReportStatePending"
                                    value="pending"
                                    defaultChecked={
                                      searchParams.ReportState === "pending"
                                    }
                                    onChange={(e) =>
                                      this.props.dispatch(
                                        actions.change(
                                          "execReportSearch.ReportState",
                                          e.target.value
                                        )
                                      )
                                    }
                                  />
                                  <Label
                                    htmlFor="ReportStatePending"
                                    className="form-check-label"
                                  >
                                    {translate("Pending")}
                                  </Label>
                                </div>
                              </fieldset>
                            </div>
                          )}
                        {view === "execReportsView" && (
                          <div className="form-group col-xl-2 col-lg-2 col-md-3 col-sm-6 col-12 custom8">
                            <fieldset>
                              <div
                                className="form-group col-lg-12 col-md-12 col-sm-12"
                                style={{
                                  padding: 0,
                                }}
                              >
                                <Label
                                  htmlFor="periodDate"
                                  className="col-form-label"
                                  style={{
                                    lineHeight: "4px",
                                    fontWeight: "700",
                                    paddingTop: "0.375rem",
                                  }}
                                >
                                  {translate("Launch period")}
                                </Label>
                                <div
                                  className="text-left"
                                  style={{
                                    display: "flex",
                                    flexDirection: "column",
                                  }}
                                >
                                  <div className="datetime-filter">
                                    <Label
                                      htmlFor="startDate"
                                      style={{
                                        padding: "0.6em",
                                        fontWeight: "600",
                                        margin: 0,
                                        width: "55px",
                                        textAlign: "left",
                                      }}
                                    >
                                      {translate("From")}
                                    </Label>
                                    <Datetime
                                      value={searchParams.Start}
                                      utc={true}
                                      locale={getMomentLocaleByLang(
                                        userLanguage
                                      )}
                                      dateFormat="DD-MM-YYYY"
                                      timeFormat="HH:mm"
                                      inputProps={{
                                        placeholder: "dd-MM-yyyy HH:mm",
                                        className:
                                          "--date-picker-custom form-control",
                                      }}
                                      onChange={(Start) => {
                                        const _date = moment(Start).toDate();
                                        this.props.dispatch(
                                          actions.change(
                                            "execReportSearch.Start",
                                            _date instanceof Date ? _date : ""
                                          )
                                        );
                                      }}
                                    />
                                  </div>
                                  <div className="datetime-filter">
                                    <Label
                                      htmlFor="endDate"
                                      style={{
                                        padding: "0.6em",
                                        fontWeight: "600",
                                        margin: 0,
                                        width: "55px",
                                        textAlign: "left",
                                      }}
                                    >
                                      {translate("Till")}
                                    </Label>
                                    <Datetime
                                      value={searchParams.End}
                                      utc={true}
                                      locale={getMomentLocaleByLang(
                                        userLanguage
                                      )}
                                      dateFormat="DD-MM-YYYY"
                                      timeFormat="HH:mm"
                                      inputProps={{
                                        placeholder: "dd-MM-yyyy HH:mm",
                                        className:
                                          "--date-picker-custom datetime-filter form-control",
                                      }}
                                      onChange={(End) => {
                                        const _date = moment(End).toDate();
                                        this.props.dispatch(
                                          actions.change(
                                            "execReportSearch.End",
                                            _date instanceof Date ? _date : ""
                                          )
                                        );
                                      }}
                                    />
                                  </div>
                                </div>
                                <div
                                  className="container time-period-btns"
                                  style={{
                                    width: "fit-content",
                                    marginTop: "1em",
                                  }}
                                >
                                  <Row>
                                    <Col style={{ padding: 0 }}>
                                      <button
                                        type="button"
                                        className="btn btn-primary btn-sm"
                                        onClick={this.onLastDayBtnClick}
                                      >
                                        {translate("LastDay")}
                                      </button>
                                    </Col>
                                    <Col style={{ padding: 0 }}>
                                      <button
                                        type="button"
                                        className="btn btn-primary btn-sm"
                                        onClick={this.onLast7DayBtnClick}
                                      >
                                        {translate("Last 7 days")}
                                      </button>
                                    </Col>
                                    <Col style={{ padding: 0 }}>
                                      <button
                                        type="button"
                                        className="btn btn-primary btn-sm"
                                        onClick={this.onLastMonthBtnClick}
                                      >
                                        {translate("Last Month")}
                                      </button>
                                    </Col>
                                  </Row>
                                </div>
                              </div>
                            </fieldset>
                          </div>
                        )}
                        {!this.props.isExternalUser && (
                          <div className="form-group col-xl-2 col-lg-2 col-md-3 col-sm-6 col-12 custom8">
                            <fieldset className="">
                              <legend
                                className="col-form-legend"
                                style={{
                                  fontSize: ".8rem",
                                  paddingBottom: "3px",
                                  fontWeight: "700",
                                }}
                              >
                                {translate("Report Type")}
                              </legend>
                              <div
                                className="col-lg-12 col-md-12 col-sm-12 form-group w_chosen external_hide"
                                style={{ marginBottom: ".4rem" }}
                              >
                                <Select
                                  name="reportTypesComboBox"
                                  className="channelComboBox chosen_static_search w_action_select allow-custom-input form-control min-width-to-100"
                                  value={
                                    view === "execReportsView"
                                      ? searchParams.TemplateId
                                      : searchParams.PipelineDefinitionId
                                  }
                                  placeholder={`${translate(
                                    "SelectReportType"
                                  )}...`}
                                  onChange={this.onSelectedReportTypeChange}
                                  options={
                                    config.reportsDescriptions &&
                                    config.reportsDescriptions &&
                                    config.reportsDescriptions.map((item) => {
                                      return {
                                        value: item.reporttemplatename,
                                        label: item.reportvisiblename,
                                      };
                                    })
                                  }
                                />
                                {view === "execReportsView" && (
                                  <div
                                    className="box"
                                    style={{ padding: "0.7em 0.5em" }}
                                  >
                                    <Input
                                      className="form-check-input"
                                      type="checkbox"
                                      defaultChecked={searchParams.HasDocuments}
                                      id="HasDocuments"
                                      onChange={(e) =>
                                        this.props.handleParamChange(
                                          "HasDocuments",
                                          e.target.checked
                                        )
                                      }
                                    />
                                    <Label
                                      htmlFor="HasDocuments"
                                      className="form-check-label"
                                    >
                                      {translate("Has Documents")}
                                    </Label>
                                  </div>
                                )}
                              </div>
                            </fieldset>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              )}
              {view === "dashboardView" && (
                <div className="col-lg-12 col-md-12 col-sm-12 col-12">
                  <div
                    className="row"
                    style={{ borderBottom: "solid 1px #CCCCCC" }}
                  >
                    <div className="col-lg-12 col-md-12 col-sm-12 col-sm-12 col-12">
                      <div
                        className="row justify-content-center top_more_style"
                        style={{ marginTop: ".5rem", marginBottom: ".5rem" }}
                      >
                        <div
                          className="form-group col-xl-4 col-lg-4 col-md-6 col-sm-12 col-24"
                          style={{ maxWidth: "100%" }}
                        >
                          <ButtonGroup>
                            <Button
                              onClick={() => this.onPeriodRadioBtnClick(1)}
                            >
                              {translate("Last 7 days")}
                            </Button>
                            <Button
                              onClick={() => this.onPeriodRadioBtnClick(2)}
                            >
                              {translate("This Month")}
                            </Button>
                            <Button
                              onClick={() => this.onPeriodRadioBtnClick(3)}
                            >
                              {translate("Last Month")}
                            </Button>
                            <Button
                              onClick={() => this.onPeriodRadioBtnClick(4)}
                            >
                              {translate("Last Year")}
                            </Button>
                            <Button
                              onClick={() => this.onPeriodRadioBtnClick(5)}
                            >
                              {translate("Last Three Months")}
                            </Button>
                            <Button
                              onClick={() => this.onPeriodRadioBtnClick(6)}
                            >
                              {translate("YTD")}
                            </Button>
                          </ButtonGroup>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </AnimateHeight>
          </div>
        </div>
        <Modal isOpen={!!this.state.msg.message} toggle={this.toggleMsgBox}>
          <ModalHeader toggle={this.toggleMsgBox}>
            {this.state.msg.header}
          </ModalHeader>
          <ModalBody>{this.state.msg.message}</ModalBody>
          <ModalFooter className="text-center">
            <button
              type="button"
              className="btn btn-primary"
              style={{ width: "100px" }}
              onClick={this.toggleMsgBox}
            >
              {translate("OK")}
            </button>
          </ModalFooter>
        </Modal>
        <Modal
          isOpen={this.state.confirmDeleteFilesModal}
          toggle={this.toggleConfirmDeleteFilesModal}
        >
          <ModalHeader toggle={this.toggleConfirmDeleteFilesModal}>
            Remove File
          </ModalHeader>
          <ModalBody>
            <FormGroup>
              <Label htmlFor="messageText">
                * Please type the reason to remove the selected files (At least
                4 chars length)
              </Label>
              <Input
                type="textarea"
                name="message"
                id="messageText"
                valid={
                  !!this.state.deleteFilesReason &&
                  this.state.deleteFilesReason.length > 3
                }
                invalid={
                  !!this.state.deleteFilesReason &&
                  this.state.deleteFilesReason.length < 4
                }
                placeholder="Tell us more.."
                value={this.state.deleteFilesReason}
                onChange={this.handleDeleteFilesReasonChange}
              />
            </FormGroup>
          </ModalBody>
          <ModalFooter className="text-center">
            <button
              type="button"
              className="btn btn-secondary"
              onClick={this.toggleConfirmDeleteFilesModal}
            >
              Cancel
            </button>
            <Button
              color="primary"
              disabled={
                !this.state.deleteFilesReason ||
                this.state.deleteFilesReason.length < 4
              }
              className="EventSearchSubmit"
              style={{ marginLeft: "20px" }}
              onClick={this.handleYesConfirmDeleteDialog}
            >
              Remove
            </Button>
          </ModalFooter>
        </Modal>
        <Modal
          isOpen={this.state.confirmDeleteFilesChannelsModal}
          toggle={this.toggleConfirmDeleteFilesChannelsModal}
        >
          <ModalHeader toggle={this.toggleConfirmDeleteFilesChannelsModal}>
            {translate("Remove channels")}
          </ModalHeader>
          <ModalBody>
            <FormGroup>
              <Label htmlFor="messageText">
                {translate("EnterReasonRemoveChannel")}
              </Label>
              <Input
                type="textarea"
                name="message"
                id="messageText"
                valid={
                  !!this.state.deleteFilesChannelsReason &&
                  this.state.deleteFilesChannelsReason.length > 3
                }
                invalid={
                  !!this.state.deleteFilesChannelsReason &&
                  this.state.deleteFilesChannelsReason.length < 4
                }
                placeholder={translate("Tell us more..")}
                value={this.state.deleteFilesChannelsReason}
                onChange={this.handleDeleteFilesChannelsReasonChange}
              />
            </FormGroup>
          </ModalBody>
          <ModalFooter className="text-center">
            <button
              type="button"
              className="btn btn-secondary"
              onClick={this.toggleConfirmDeleteFilesChannelsModal}
            >
              {translate("Cancel")}
            </button>
            <Button
              color="primary"
              disabled={
                !this.state.deleteFilesChannelsReason ||
                this.state.deleteFilesChannelsReason.length < 4
              }
              className="EventSearchSubmit"
              style={{ marginLeft: "20px" }}
              onClick={this.handleYesConfirmDeleteChannelsDialog}
            >
              {translate("Remove")}
            </Button>
          </ModalFooter>
        </Modal>
        <Modal
          isOpen={this.state.confirmDeleteFilesChannelsModal}
          toggle={this.toggleConfirmDeleteFilesChannelsModal}
        >
          <ModalHeader toggle={this.toggleConfirmDeleteFilesChannelsModal}>
            Remove Channels
          </ModalHeader>
          <ModalBody>
            <FormGroup>
              <Label htmlFor="messageText">
                * Please type the reason to remove the selected channels (At
                least 4 chars length)
              </Label>
              <Input
                type="textarea"
                name="message"
                id="messageText"
                valid={
                  !!this.state.deleteFilesChannelsReason &&
                  this.state.deleteFilesChannelsReason.length > 3
                }
                invalid={
                  !!this.state.deleteFilesChannelsReason &&
                  this.state.deleteFilesChannelsReason.length < 4
                }
                placeholder="Tell us more.."
                value={this.state.deleteFilesChannelsReason}
                onChange={this.handleDeleteFilesChannelsReasonChange}
              />
            </FormGroup>
          </ModalBody>
          <ModalFooter className="text-center">
            <button
              type="button"
              className="btn btn-secondary"
              onClick={this.toggleConfirmDeleteFilesChannelsModal}
            >
              Cancel
            </button>
            <Button
              color="primary"
              disabled={
                !this.state.deleteFilesChannelsReason ||
                this.state.deleteFilesChannelsReason.length < 4
              }
              className="EventSearchSubmit"
              style={{ marginLeft: "20px" }}
              onClick={this.handleYesConfirmDeleteChannelsDialog}
            >
              Remove
            </Button>
          </ModalFooter>
        </Modal>
      </>
    );
  }
}

function mapStateToProps(state) {
  const { config, fileSearch, reports, locale, authentication } = state;
  const { user, subUser } = authentication;
  const { configuredReports } = reports;
  return {
    config,
    configuredReports,
    user,
    subUser,
    fileSearch,
    selectedFiles: state.files.selectedFiles,
    selectedFlowIdsChannels: state.files.selectedFlowIdsChannels,
    allFiles: state.files.items,
    selectedExecReports: state.reports.selectedExecReports,
    selCustomerConfigReportsSize: config.selCustomerConfigReportsSize,
    docsViewActiveTabs: config.docsViewActiveTabs,
    translate: getTranslate(locale),
    tagsOptions: config.tagsOptions,
  };
}

const connectedSearchPanel = connect(mapStateToProps)(withRouter(SearchPanel));
export { connectedSearchPanel as SearchPanel };
